import {
    Form,
    Input,
    InputNumber,
    Button,
    Tabs,
    Radio,
    Select,
    DatePicker,
    Upload,
    notification,
    message,
    Row,
    Col,
    Modal,
    Divider,
    Typography,
    Table,
    Space,
    Tag,
    Tooltip,
    Image,
    Collapse,
    Checkbox,
    Popover,
    Breadcrumb,
} from 'antd';
import {
    LoadingOutlined,
    PlusOutlined,
    InfoCircleOutlined,
    WarningFilled,
    ArrowDownOutlined,
    ArrowUpOutlined,
    MinusCircleOutlined,
    PlusCircleOutlined,
    EditFilled,
    DeleteFilled,
    BackwardOutlined,
    ForwardOutlined,
    CloseCircleFilled,
    InteractionOutlined,
    InteractionFilled,
} from '@ant-design/icons';
import { useContext, useEffect, useState } from 'react';
import moment from "moment";

import './styles.css';
import { Context } from '../../context';
import { Delete, Fetch, Post, Put } from '../../fetch';
import { convertIdToKey, countryCodes, currencycodes } from '../../utils';
import UploadVideo from '../UploadContent/videos';
import UploadTrailer from '../UploadContent/trailers';
import UploadSubtitles from '../UploadContent/subtitles';
import Column from 'antd/lib/table/Column';
import UploadAudio from '../UploadContent/audio';

const { TabPane } = Tabs;
const { TextArea } = Input;
const { Option } = Select;
const { Panel } = Collapse;

const ManageContent = ({ updateTab }) => {
    const [activeTab, setActiveTab] = useState('1');
    const [activeKey, setActiveKey] = useState('1');
    const [contentKey, setContentKey] = useState('1');
    const [refresh, setRefresh] = useState(false);
    const [refreshMovies, setRefreshMovies] = useState(false);
    const [refreshSeries, setRefreshSeries] = useState(false);
    const [contentType, setContentType] = useState('movie');
    const [availability, setAvailability] = useState('perpetual');
    const [monetizationModel, setMonetizationModel] = useState('');
    const [modelType, setModelType] = useState('default')
    const [movies, setMovies] = useState([]);
    const [series, setSeries] = useState([]);
    const [albums, setAlbums] = useState([]);
    const [saved, setSaved] = useState(false);
    const [maturityTpe, setMaturityType] = useState('CBFC');
    const [count, setCount] = useState(0);
    const [activeObj, setActiveObj] = useState({});
    const [listType, setListType] = useState('allow_all');
    const [showModal, setShowModal] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [showTable, setShowTable] = useState(true);
    const [showTitle, setShowTitle] = useState(false);
    const [filter, setFilter] = useState('all');
    const [Telugu, setTelugu] = useState(false);
    const [Hindi, setHindi] = useState(false);
    const [Tamil, setTamil] = useState(false);
    const [title, setTitle] = useState(false);
    const [ratingType, setRatingType] = useState('CBFC');
    const [id, setId] = useState('');
    const [role, setRole] = useState('');
    const [upload, setUpload] = useState({
        id: null,
        season: null,
        episode: null,
        type: '',
    });

    const initUpload = {
        id: null,
        season: null,
        episode: null,
        type: "",
    };

    useEffect(() => {
        setActiveObj({});
        setUpload(initUpload);
    }, [contentType]);

    const codes = ["INR", "BDT", "GBP", "NPR", "MUR", "SGD", "AED", "EUR", "USD"];

    const [seriesId, setSeriesId] = useState();
    const [episodesData, setEpisodesData] = useState([]);
    const ep_form = []
    const [seriesName, setSeriesName] = useState('');
    const [season, setSeason] = useState(1);
    const [movie, setMovie] = useState();
    const [movieName, setMovieName] = useState('');
    const [deleteEpisode, setDeleteEpisode] = useState({});
    const allowList = []
    let del_list = []
    const [dateString, setDateString] = useState(null);

    const { token, apiUrl, superAdmin } = useContext(Context);

    const [contentInfoForm] = Form.useForm();
    const [seriesContentInfoForm] = Form.useForm();

    const [castCrewAvailabilityForm] = Form.useForm();
    const [seriesCastCrewAvailabilityForm] = Form.useForm();

    const [episodesForm] = Form.useForm();

    const [posterBannersForm] = Form.useForm();
    const [geoAccessForm] = Form.useForm();
    const [monetizationStreamingForm] = Form.useForm();
    const [standAloneForm] = Form.useForm();
    const [titleForm] = Form.useForm();
    const [videoAssetsForm] = Form.useForm();

    const [actors, setActors] = useState([]);
    const [directors, setDirectors] = useState([]);
    const [writers, setWriters] = useState([]);
    const [studios, setStudios] = useState([]);
    const [singers, setSingers] = useState([]);
    const [lyricists, setLyricists] = useState([]);
    const [genres, setGenres] = useState([]);
    const [languages, setLanguages] = useState([]);

    const [cardImageLoading, setCardImageLoading] = useState(false);
    const [detailImageLoading, setDetailImageLoading] = useState(false);
    const [trailerImageLoading, setTrailerImageLoading] = useState(false);
    const [uploadStatus, setUploadStatus] = useState(false)
    const [cardImageUrl, setCardImageUrl] = useState();
    const [detailImageUrl, setDetailImageUrl] = useState();
    const [trailerImageUrl, setTrailerImageUrl] = useState();
    const [addStandaloneContent, setAddStandaloneContent] = useState(false);
    const [addSeriesContent, setAddSeriesContent] = useState(false);
    const [seriesTitleModal, setSeriesTitleModal] = useState(false);
    const [selectionType, setSelectionType] = useState('checkbox');

    const { Text, Link, Title } = Typography;

    const [addStandloneTitleForm] = Form.useForm();
    const [addSeriesTitleForm] = Form.useForm();

    const ratings = [
        {
            type: 'CBFC — Central Board of Film Certification',
            value: 'CBFC'
        },
        {
            type: 'BR Official Rating',
            value: 'BR'
        }
    ]

    let ratingValues = ratingType === 'CBFC' ? [
        {
            key: 'U',
            value: 'U',
        },
        {
            key: 'U/A',
            value: 'U/A'
        },
        {
            key: 'A',
            value: 'A',
        },
        {
            key: 'S',
            value: 'S',
        },
    ] : ratingType === 'BR' ? [
        {
            key: 'L',
            value: 'L',
        },
        {
            key: '10',
            value: '10',
        },
        {
            key: '12',
            value: '12',
        },
        {
            key: '14',
            value: '14',
        },
        {
            key: '16',
            value: '16',
        },
        {
            key: '18',
            value: '18',
        },
    ] : []

    //  Episodes Sorting Buttons
    const episodesSortingButtons = () => {
        return (
            <>
                <Button style={{ marginRight: '10px' }}>
                    <ArrowDownOutlined />
                </Button>
                <Button>
                    <ArrowUpOutlined />
                </Button>
            </>
        );
    };

    //  addLanguage Popover
    const addLanguagePopover = () => {
        return (
            <Row>
                <Col span="24">
                    <Checkbox onChange={(e) => setTelugu(e.target.checked)} checked={Telugu}>Telugu</Checkbox>
                    <br />
                    <Checkbox onChange={(e) => setHindi(e.target.checked)} checked={Hindi}>Hindi</Checkbox>
                    <br />
                    <Checkbox onChange={(e) => setTamil(e.target.checked)} checked={Tamil}>Tamil</Checkbox>
                </Col>
            </Row>
        );
    };

    useEffect(() => {
        setCount(contentKey);

        return () => {
            setAddStandaloneContent(false);
        };
    }, [contentKey, contentType, activeTab]);

    const cardImageUploadButton =
        contentType === 'movie' || contentType === 'song' ? (
            <div>
                {cardImageLoading ? <LoadingOutlined /> : <PlusOutlined />}
                <div style={{ marginTop: 8 }}>Upload (300x400)</div>
            </div>
        ) : (
            <div>
                {cardImageLoading ? <LoadingOutlined /> : <PlusOutlined />}
                <div style={{ marginTop: 8 }}>Upload (450x250)</div>
            </div>
        );

    const detailImageUploadButton = (
        <div>
            {detailImageLoading ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>Upload (1500x500)</div>
        </div>
    );

    const trailerImageUploadButton = (
        <div>
            {trailerImageLoading ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>Upload (512x288)</div>
        </div>
    );

    const beforeImageUpload = (file) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('Only JPG and PNG files are allowed');
        }
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!isLt2M) {
            message.error('Image must be smaller than 1M');
        }

        return isJpgOrPng && isLt2M;
    };

    const handleCardImageUploadStatusChange = (info) => {
        if (info.file.status === 'uploading') {
            setCardImageLoading(true);
            return;
        }

        if (info.file.status === 'done') {
            setCardImageLoading(false);
            setCardImageUrl(info.file.response.url);
            posterBannersForm.setFieldsValue({ cardImage: info.file.response.url });
            setUploadStatus(false)
        }
    };

    const handleDetailImageUploadStatusChange = (info) => {
        if (info.file.status === 'uploading') {
            setDetailImageLoading(true);
            return;
        }

        if (info.file.status === 'done') {
            setDetailImageLoading(false);
            setDetailImageUrl(info.file.response.url);
            posterBannersForm.setFieldsValue({ detailImage: info.file.response.url });
        }
    };

    const handleTrailerImageUploadStatusChange = (info) => {
        if (info.file.status === 'uploading') {
            setTrailerImageLoading(true);
            return;
        }

        if (info.file.status === 'done') {
            setTrailerImageLoading(false);
            setTrailerImageUrl(info.file.response.url);
            posterBannersForm.setFieldsValue({
                trailerImage: info.file.response.url,
            });
        }
    };

    const handlePreview = (info) => {
        console.log("info - ", info)
    }

    useEffect(() => {
        Fetch(`${apiUrl}/movies`, token, (result) => {
            let movies = convertIdToKey(result.movies);
            let m = [];
            movies.forEach((movie) => {
                if (!movie.availability) movie.availability = 'unpublished';
                if (!movie.title) {
                    movie["title"] = "NA"
                }
                if (filter === 'draft' && movie.availability === 'unpublished') {
                    m.push(movie);
                } else if (
                    filter === 'published' &&
                    movie.availability === 'perpetual'
                ) {
                    m.push(movie);
                }
                if (filter === 'all') {
                    m.push(movie);
                }
            });
            movies.forEach((movie) => {
                if (typeof movie["genre"] === "string") {
                    movie["genre"] = [movie["genre"]];
                }

                if (!movie.duration) {
                    movie.duration = "--:--:--";
                }
                if (movie.createdAt) {
                    movie.createdAt = moment(movie.createdAt).format("DD/MM/YYYY hh:mm A");
                } else {
                    movie.createdAt = "-"
                }
            });
            setMovies(m);
            setRefreshMovies(false);
        });

        Fetch(`${apiUrl}/series`, token, (result) => {
            let series = convertIdToKey(result.series);
            let m = [];
            series.forEach((s) => {
                if (!s.availability) s.availability = 'unpublished';
                if (filter === 'draft' && s.availability === 'unpublished') {
                    m.push(s);
                } else if (filter === 'published' && s.availability === 'perpetual') {
                    m.push(s);
                }
                if (filter === 'all') {
                    m.push(s);
                }
            });
            series.forEach((su) => {
                if (!su.videoUploadDateTime) {
                    su.videoUploadDateTime = "NA";
                } else {
                    su.videoUploadDateTime = moment(su.videoUploadDateTime).format(
                        "DD/MM/YYYY hh:mm A"
                    );
                }
                if (!su.duration) {
                    su.duration = "--:--:--";
                }
                if (su.createdAt) {
                    su.createdAt = moment(su.createdAt).format("DD/MM/YYYY hh:mm A");
                } else {
                    su.createdAt = "-"
                }
            });
            setSeries(m);
            setRefreshSeries(false);
        });

        Fetch(`${apiUrl}/artists`, token, (result) => {
            setActors(result.artists);
        });

        Fetch(`${apiUrl}/mediaHouses`, token, (result) => {
            setDirectors(result.directors);
            setWriters(result.writers);
            setSingers(result.singers);
            setLyricists(result.lyricists);
            setStudios(result.studios);
        });

        Fetch(`${apiUrl}/genres`, token, (result) => {
            setGenres(result.genres);
        });

        Fetch(`${apiUrl}/languages`, token, (result) => {
            setLanguages(result.languages);
        });
    }, [apiUrl, token, filter, refreshMovies, refreshSeries]);


    const handleContentInfoSubmit = async () => {
        let contentInfo = await contentInfoForm.validateFields();
        console.log('content info form values  - ', contentInfo)
        let valid = true
        try {
            contentInfo = await contentInfoForm.validateFields();
            if (contentInfo.releaseDate) {
                contentInfo.releaseDate = contentInfo.releaseDate.toISOString();
            }
        } catch (err) {
            console.error(err);
            notification.error({
                message: "Content Info Error",
                description: "Required fields are incorrect/missing",
            });
            valid = false;
        }
        contentInfo = {
            ...contentInfo,
            cardImage: cardImageUrl,
            detailImage: detailImageUrl,
            trailerImage: trailerImageUrl,
        }
        if (contentType === 'movie') {
            let movieId = sessionStorage.getItem('content_id')
            Put(
                `${apiUrl}/movies/${movieId}`, token, { ...contentInfo }, (result) => {
                    if (result.success) {
                        notification.success({
                            message: 'Success',
                            description: 'Movie Saved'
                        })
                        setActiveKey("2");
                    }
                }
            )

        }
        console.log(seriesId)
        if (contentType === 'series' && seriesId) {
            // console.log('series id before api call - ', seriesId)
            Post(
                `${apiUrl}/series/${seriesId}/episodes`, token, { ...contentInfo }, (result) => {
                    console.log(result)
                    if (result.success) {
                        sessionStorage.setItem('content_id', seriesId)
                        console.log(sessionStorage.getItem('content_id'))
                        notification.success({
                            message: 'Success',
                            description: 'Episode Saved'
                        })
                        // console.log(contentInfo)
                        sessionStorage.setItem('episode_data', JSON.stringify(contentInfo))
                        console.log("episode data after updating - ", JSON.parse(sessionStorage.getItem('episode_data')))
                    }
                }
            )
        }
        if (contentType === 'song') {
            Post(
                `${apiUrl}/songs`, token, { ...contentInfo }, (result) => {
                    if (result.success) {
                        console.log("song id - ", result.success)
                        sessionStorage.setItem('content_id', result.success)
                        notification.success({
                            message: 'Success',
                            description: 'Song Saved'
                        })
                    }
                }
            )
        }

    }

    const handleSeriesContentInfoSubmit = async () => {
        let contentInfo = await seriesContentInfoForm.validateFields();
        let valid = true
        try {
            contentInfo = await seriesContentInfoForm.validateFields();
            if (contentInfo.releaseDate) {
                contentInfo.releaseDate = contentInfo.releaseDate.toISOString();
            }
        } catch (err) {
            console.error(err);
            notification.error({
                message: "Content Info Error",
                description: "Required fields are incorrect/missing",
            });
            valid = false;
        }
        contentInfo = {
            ...contentInfo,
            cardImage: cardImageUrl,
            detailImage: detailImageUrl,
            trailerImage: trailerImageUrl,
        }
        let id = sessionStorage.getItem('content_id');
        if (id) {
            Put(
                `${apiUrl}/series/${id}`, token, { ...contentInfo }, (result) => {
                    console.log(result)
                    if (result.success) {
                        notification.success({
                            message: 'Success',
                            description: 'Episode Saved'
                        })
                        setActiveKey("2");
                    }
                }
            )
        }
    }

    const handleCastCrewSubmit = async () => {
        let castCrewAvailability
        let valid = false
        try {
            castCrewAvailability = await castCrewAvailabilityForm.validateFields();
            console.log(castCrewAvailability);
        } catch (err) {
            console.error(err);
            notification.error({
                message: "Cast & Crew Error",
                description: "Required fields are incorrect/missing",
            });
            valid = false;
        }
        let id = sessionStorage.getItem('content_id')
        if (id) {
            console.log('content_id - ', id)
            if (contentType === 'movie') {
                Put(
                    `${apiUrl}/movies/${id}`, token, { ...castCrewAvailability }, (result) => {
                        if (result.success) {
                            notification.success({
                                message: 'Success',
                                description: 'Movie Saved'
                            })
                            setActiveKey("3");
                        }
                    }
                )

            }
            if (contentType === 'series' && seriesId) {
                try {
                    const castCrewAvailability = await castCrewAvailabilityForm.validateFields();
                    let episode = JSON.parse(sessionStorage.getItem('episode_data'))
                    // console.log('episode data before updating cast crew - ', episode)
                    let newEpisode = { ...episode, ...castCrewAvailability }
                    Post(
                        `${apiUrl}/series/${seriesId}/episodes`,
                        token,
                        {
                            ...newEpisode,
                            old: { ...episode },
                        },
                        (result) => {
                            if (result.success) {
                                notification.success({
                                    message: "Success",
                                    description: "Epsiode edited",
                                });
                                sessionStorage.setItem('episode_data', JSON.stringify(newEpisode))
                                // console.log("episode data after cast and Crew - ", JSON.parse(sessionStorage.getItem('episode_data')))
                            }
                        },
                        () => {
                            notification.error({
                                message: "Error",
                                description: "Please check console for more details",
                            });
                        }
                    );
                } catch (err) {
                    console.error(err);
                    notification.error({
                        message: "Error",
                        description: "Required fields incorrect/missing",
                    });
                }
            }
            if (contentType === 'song') {
                Put(
                    `${apiUrl}/songs/${id}`, token, { ...castCrewAvailability }, (result) => {
                        if (result.success) {
                            notification.success({
                                message: 'Success',
                                description: 'Song Saved'
                            })
                        }
                    }
                )
            }
        }

    }


    const handleSeriesCastCrewSubmit = async () => {
        let castCrewAvailability
        let valid = false
        try {
            castCrewAvailability = await seriesCastCrewAvailabilityForm.validateFields();
            console.log(castCrewAvailability);
        } catch (err) {
            console.error(err);
            notification.error({
                message: "Cast & Crew Error",
                description: "Required fields are incorrect/missing",
            });
            valid = false;
        }
        let id = sessionStorage.getItem('content_id')
        if (id) {
            console.log('content_id - ', id)
            try {
                Put(
                    `${apiUrl}/series/${id}`,
                    token,
                    {
                        ...castCrewAvailability
                    },
                    (result) => {
                        if (result.success) {
                            notification.success({
                                message: "Success",
                                description: "Series Saved",
                            });
                            setActiveKey('3');
                        }
                    },
                    () => {
                        notification.error({
                            message: "Error",
                            description: "Please check console for more details",
                        });
                    }
                );
            } catch (err) {
                console.error(err);
                notification.error({
                    message: "Error",
                    description: "Required fields incorrect/missing",
                });
            }
        }
    }

    const handleVideoAssestsSubmit = async () => {
        let videoAssets
        let valid = false
        try {
            videoAssets = await videoAssetsForm.validateFields();
            console.log(videoAssets);
        } catch (err) {
            console.error(err);
            notification.error({
                message: "Video Assets Error",
                description: "Required fields are incorrect/missing",
            });
            valid = false;
        }
        let id = sessionStorage.getItem('content_id')
        if (id) {
            console.log('content_id - ', id)
            if (contentType === 'movie') {
                Put(
                    `${apiUrl}/movies/${id}`, token, { ...videoAssets }, (result) => {
                        if (result.success) {
                            notification.success({
                                message: 'Success',
                                description: 'Movie Saved'
                            })
                            setActiveKey("4");
                        }
                    }
                )

            }
        }
    }

    const handleDeleteEpisode = async (key, checked) => {
        // console.log('epsode number - ', key);
        // console.log('should delete - ', checked);
        del_list.push({ 'key': key, 'delete': checked })
    }

    const checkSubmitValidation = (data) => {
        let accept = data.filter(v => 'del_box' in v && v['del_box'] === false);
        accept.forEach((e) => {
            if (!e["ep_cardImage"] || !e["ep_title"] || !e["ep_description"]) {
                return false
            }
        })

        return true
    }

    const handleEpisodeSubmit = async () => {
        const episodes = await episodesForm.getFieldsValue();
        console.log('episodes data in submit - ', episodes.episodes)
        // console.log('del_list - ', del_list)
        let ep_data = episodes.episodes
        let values = []
        console.log("ep_data - ", ep_data)
        ep_data = ep_data.filter(v => v !== undefined)
        if (!checkSubmitValidation(ep_data)) {
            notification.error({
                message: "Update Episodes Error",
                description: "Required fields are missing"
            })
            return;
        }
        ep_data.forEach((ep) => {
            ep['season'] = season;
            try {
                ep['ep_cardImage'] = ep['ep_cardImage'].file.response.url;
            }
            catch {
                ep["ep_cardImage"] = ep["ep_cardImage"]
            }
        });
        ep_data = ep_data.filter(e => e.del_box === false);
        values = ep_data.concat(episodesData);
        let id = sessionStorage.getItem('content_id')
        if (id) {
            Put(
                `${apiUrl}/series/${id}`, token, { episodes: values }, (result) => {
                    if (result.success) {
                        notification.success({
                            message: 'Success',
                            description: 'Episodes Updated'
                        });
                        setActiveKey("1");
                        del_list = []
                        setRefresh(true)
                    }
                }
            )
        }
    }

    useEffect(() => {
        console.log('refresh is now - ', refresh)
        if (refresh) {
            let id = sessionStorage.getItem('content_id');
            let data = { 'key': id }
            handleFetchSeries(data)
            setActiveTab('2');
            setActiveKey('3');
            setRefresh(false);
            console.log('the series id is - ', id)
        }

    }, [refresh])

    const handleAvailabilitySubmit = async () => {
        let geoAccess
        let valid = true
        try {
            geoAccess = await geoAccessForm.validateFields();
            if (listType === 'allow') {
                for (const i in countryCodes) {
                    if (geoAccess.countryMap.includes(i)) allowList.push(i)
                }
                console.log(allowList)
            }
            if (listType === 'disallow') {
                for (const i in countryCodes) {
                    if (!geoAccess.countryMap.includes(i)) allowList.push(i)
                }
                console.log(allowList)
            }
            if (listType === 'allow_all') {
                for (const i in countryCodes) {
                    allowList.push(i)
                }
            }
        } catch (err) {
            console.error(err);
            notification.error({
                message: "Geo Access Error",
                description: "Required fields are incorrect/missing",
            });
            valid = false;
        }
        let id = sessionStorage.getItem('content_id')
        if (id) {
            console.log('content_id - ', id)
            if (contentType === 'movie') {
                Put(
                    `${apiUrl}/movies/${id}`, token,
                    {
                        allowedCountries: allowList,
                        listType: listType
                    },
                    (result) => {
                        if (result.success) {
                            notification.success({
                                message: 'Success',
                                description: 'Movie Saved'
                            })
                        }
                    }
                )

            }
        }
    }

    const handleSeriesAvailabilitySubmit = async () => {
        let geoAccess
        let valid = true
        try {
            geoAccess = await geoAccessForm.validateFields();
            if (listType === 'allow') {
                for (const i in countryCodes) {
                    if (geoAccess.countryMap.includes(i)) allowList.push(i)
                }
                console.log(allowList)
            }
            if (listType === 'disallow') {
                for (const i in countryCodes) {
                    if (!geoAccess.countryMap.includes(i)) allowList.push(i)
                }
                console.log(allowList)
            }
            if (listType === 'allow_all') {
                for (const i in countryCodes) {
                    allowList.push(i)
                }
            }
        } catch (err) {
            console.error(err);
            notification.error({
                message: "Geo Access Error",
                description: "Required fields are incorrect/missing",
            });
            valid = false;
        }
        let id = sessionStorage.getItem('content_id')
        if (id) {
            console.log('content_id - ', id)
            Put(
                `${apiUrl}/series/${id}`, token,
                {
                    allowedCountries: allowList,
                    listType: listType
                },
                (result) => {
                    if (result.success) {
                        notification.success({
                            message: 'Success',
                            description: 'Series Saved'
                        })
                    }
                }
            )
        }
    }

    const handleReset = () => {
        sessionStorage.removeItem('content_id');
        setAddStandaloneContent(false);
        setAddSeriesContent(false);
        setShowTable(true);
    }

    const handleFetchMovie = (record) => {
        console.log(record)
        Fetch(
            `${apiUrl}/movies/${record.key}`, token, (result) => {
                if (result) {
                    setMovie(result);
                    if (result.teluguTitle || result.teluguDescription) setTelugu(true);
                    if (result.hindiTitle || result.hindiDescription) setHindi(true);
                    if (result.tamilTitle || result.tamilDescription) setTamil(true);
                    sessionStorage.setItem('content_id', record.key);
                    setShowTable(false);
                    setAddStandaloneContent(true);
                    if (result.cardImage) {
                        setCardImageUrl(result.cardImage);
                    }
                    if (result.detailImage) {
                        setDetailImageUrl(result.detailImage);
                    }
                    if (result.trailerImage) {
                        setTrailerImageUrl(result.trailerImage);
                    }
                    contentInfoForm.setFieldsValue(result);
                    castCrewAvailabilityForm.setFieldsValue(result);
                    let values = result.allowedCountries
                    if (result.listType) {
                        setListType(result.listType)
                        geoAccessForm.setFieldValue('listType', result.listType)
                    } else {
                        setListType('allow_all')
                        geoAccessForm.setFieldValue('listType', 'allow_all')
                    }
                    let countries = []
                    if (result.listType === 'allow') {
                        geoAccessForm.setFieldValue('countryMap', values)
                    }
                    if (result.listType === 'disallow') {
                        for (const i in countryCodes) {
                            if (!values.includes(i)) {
                                countries.push(i)
                            }
                        }
                        geoAccessForm.setFieldValue('countryMap', countries)
                        countries = []
                    }
                }
            }
        )
    }

    const seasonDown = async () => {
        if (season > 1) await setSeason(season - 1);
        else {
            notification.warning({
                message: 'Invalid Season Number',
                description: 'Cannot be Zero'
            });
            return;
        }
        let id = sessionStorage.getItem('content_id');
        let data = { 'key': id }
        setRefresh(true);
        await handleFetchSeries(data)
    }

    useEffect(() => {
        console.log('use effect episodes - ', episodesData)
    }, [episodesData]);

    const seasonUp = async () => {
        await setSeason(season + 1);
        let id = sessionStorage.getItem('content_id');
        let data = { 'key': id }
        setRefresh(true);
        await handleFetchSeries(data)
    }

    const handleFetchSeries = (record) => {
        console.log(record);
        setRefresh(true);
        Fetch(`${apiUrl}/series/${record.key}`, token, (result) => {
            if (result) {
                if (result.teluguTitle || result.teluguDescription) setTelugu(true);
                if (result.hindiTitle || result.hindiDescription) setHindi(true);
                if (result.tamilTitle || result.tamilDescription) setTamil(true);
                setDateString(moment(result.releaseDate).format("YYYY-MM-DD"))
                setSeriesId({ ...result, releaseDate: moment(result.releaseDate).format("YYYY-MM-DD") })
                sessionStorage.setItem('content_id', record.key);
                setContentType('series');
                setShowTable(false)
                setAddSeriesContent(true);
                if (result.cardImage) {
                    setCardImageUrl(result.cardImage);
                }
                if (result.detailImage) {
                    setDetailImageUrl(result.detailImage);
                }
                if (result.trailerImage) {
                    setTrailerImageUrl(result.trailerImage);
                }
                seriesContentInfoForm.setFieldsValue(result);
                seriesCastCrewAvailabilityForm.setFieldsValue(result);
                let episodes = result.episodes
                const episodes_data = episodes.filter(e => e.season !== season)
                console.log('episodes of other seasons - ', episodes_data);
                setEpisodesData(episodes_data);
                const ep = episodes.filter(e => e.season === season)
                console.log('episodes data while fetching series - ', ep, ' season - ', season - 1);
                if (ep.length >= 1) {
                    ep.forEach((e) => {
                        if (!ep.ep_cardImage) {
                            ep["ep_cardImage"] = "NA"
                        }
                    })
                    episodesForm.setFieldValue('episodes', ep);
                }
                let values = result.allowedCountries
                if (result.listType) {
                    setListType(result.listType)
                    geoAccessForm.setFieldValue('listType', result.listType)
                } else {
                    setListType('allow_all')
                    geoAccessForm.setFieldValue('listType', 'allow_all')
                }
                let countries = []
                if (result.listType === 'allow') {
                    geoAccessForm.setFieldValue('countryMap', values)
                }
                if (result.listType === 'disallow') {
                    for (const i in countryCodes) {
                        if (!values.includes(i)) {
                            countries.push(i)
                        }
                    }
                    geoAccessForm.setFieldValue('countryMap', countries)
                    countries = []
                }
            }
        })
    }

    const handleDeleteStandaloneContent = (record) => {

        console.log('the selected content is - ', record)
        Delete(
            `${apiUrl}/movies/${record.key}`, token, (result) => {
                if (result.success) {
                    notification.success({
                        message: 'Deleted',
                        description: 'Content Deleted Successfully'
                    });
                }
                setRefreshMovies(true);
            }
        )
    }

    const handleDeleteSeriesContent = (record) => {
        console.log('the selected content is - ', record);
        Delete(
            `${apiUrl}/series/${record.key}`, token, (result) => {
                if (result.success) {
                    notification.success({
                        message: 'Deleted',
                        description: 'Content Deleted Succesfully'
                    });
                }
                setRefreshSeries(true);
            }
        )
    }

    const handleStandAloneTitleSubmit = async () => {
        let values = await addStandloneTitleForm.validateFields();
        console.log('standalone title form values - ', values)

        if (contentType === 'movie') {
            Post(
                `${apiUrl}/movies`, token, { ...values }, (result) => {
                    if (result.success) {
                        sessionStorage.setItem('content_id', result.content_id);
                        notification.success({
                            message: 'Success',
                            description: 'Title Added Successfully'
                        });
                        setShowModal(false);
                        setAddStandaloneContent(true);
                        setShowTable(false);
                        setMovie(values)
                        console.log(movie)
                        contentInfoForm.setFieldsValue(values)
                    }
                }
            )
        }
    }

    const handleSeriesTitleSubmit = async () => {
        let values = await addSeriesTitleForm.validateFields();
        console.log('episodic title form values - ', values);

        Post(
            `${apiUrl}/series`, token, { ...values }, (result) => {
                if (result.success) {
                    sessionStorage.setItem('content_id', result.content_id);
                    notification.success({
                        message: 'Success',
                        description: 'Title Added Successfully'
                    });
                    setSeriesTitleModal(false);
                    setAddSeriesContent(true);
                    setShowTable(false);
                    setSeriesId(values);
                    console.log(seriesId);
                }
            }
        )
    }

    const playStandAloneContent = async () => {
        console.log('content being played');
    }

    const playSeriesContent = async () => {
        console.log('content being played');
    }

    const handleBreadCrumb = () => {
        setTitle(false);
        setMovie(null);
        setSeriesId(null);
        setShowTable(true);
    }

    const publishStandaloneContent = (record) => {
        console.log(record)
        Put(
            `${apiUrl}/movies/${record.key}`, token,
            { "availability": record.availability === "unpublished" ? "perpetual" : "unpublished" },
            (result) => {
                notification.success({
                    success: "Success",
                    description: `Content ${record.availability === "unpublished" ? "Published" : "Unpublished"} successfully`
                })
                setRefreshMovies(true);
            }
        )
    }

    const publishEpisodicContent = (record) => {
        console.log(record)
        Put(
            `${apiUrl}/series/${record.key}`, token,
            { "availability": record.availability === "unpublished" ? "perpetual" : "unpublished" },
            (result) => {
                notification.success({
                    success: "Success",
                    description: `Content ${record.availability === "unpublished" ? "Published" : "Unpublished"} successfully`
                })
                setRefreshSeries(true);
            }
        )
    }

    return (
        <>
            <div className="add-content-wrapper">
                {!addStandaloneContent && !addSeriesContent ? (
                    <>
                        {/* <Col span={'100%'} style={{ marginBottom: '20px' }}>
                        </Col> */}
                        <Row
                            style={{
                                backgroundColor: '#fff',
                                padding: '10px 20px 10px 10px',
                                borderBottom: '1px solid #eee',
                            }}
                        >
                            <Col span={'80%'}>
                                <Title level={4} align='left'>
                                    Manage Content
                                </Title>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Tabs
                                    activeKey={activeTab}
                                    onChange={async (tab) => {
                                        await setActiveTab(tab);
                                        setSaved(false);
                                        setShowTable(true);
                                        standAloneForm.resetFields();
                                        titleForm.resetFields();
                                        setTitle(false);
                                        console.log(contentType);
                                    }}
                                    className="add-content-tabs addContentTabs"
                                >
                                    <TabPane
                                        tab={
                                            <>
                                                <div className="tabMainTitle">Standalone</div>
                                                <span className="tabSubTitle">
                                                    Movies, Shorts and Songs
                                                </span>
                                            </>
                                        }
                                        key="1"
                                    >
                                        {showTable && (
                                            <>
                                                <Row>
                                                    <Select
                                                        placeholder="Search Movie"
                                                        showSearch
                                                        allowClear
                                                        onChange={(_, record) => {
                                                            handleFetchMovie(record);
                                                        }}
                                                        onClear={() => setFilter('all')}
                                                        style={{ width: '100%', marginBottom: '15px' }}
                                                        optionFilterProp="children"
                                                        filterOption={(input, option) =>
                                                            option.children
                                                                .toLowerCase()
                                                                .indexOf(input.toLowerCase()) >= 0
                                                        }
                                                        filterSort={(optionA, optionB) =>
                                                            optionA.children
                                                                .toLowerCase()
                                                                .localeCompare(optionB.children.toLowerCase())
                                                        }
                                                    >
                                                        {movies.map((m) => (
                                                            <Option key={m.key} value={m.title}>
                                                                {m.title}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </Row>
                                                <Row
                                                    justify={'space-between'}
                                                    style={{ marginBottom: '25px' }}
                                                >
                                                    <Col>
                                                        {!showModal && (
                                                            <Button
                                                                className="title-btn"
                                                                type="primary"
                                                                onClick={() => {
                                                                    /* setShowTable(false);
                                                            handleTitleUpdate();
                                                            setShowTitle(true); */
                                                                    setShowModal(true);
                                                                }}
                                                            >
                                                                Add Title
                                                            </Button>
                                                        )}
                                                    </Col>
                                                    <Col>
                                                        <Select
                                                            defaultValue="all"
                                                            style={{ width: 120 }}
                                                            onChange={(value) => {
                                                                setFilter(value);
                                                            }}
                                                            options={[
                                                                { value: 'all', label: 'View All' },
                                                                { value: 'draft', label: 'Draft' },
                                                                { value: 'published', label: 'Published' },
                                                            ]}
                                                        />
                                                    </Col>
                                                </Row>

                                                <Table dataSource={movies}>
                                                    <Column
                                                        title="Title"
                                                        dataIndex="title"
                                                        key="title"
                                                        align="left"
                                                        width={'50%'}
                                                        paddingLeft={'3%'}
                                                        render={(_, record) => record.title ? record.title : '-'}
                                                    />
                                                    <Column
                                                        title="Duration"
                                                        dataIndex={"duration"}
                                                        key="duration"
                                                        align='center'
                                                        render={(_, record) => record.duration ? record.duration : '--:--:--'}
                                                    />
                                                    <Column
                                                        title="Status"
                                                        dataIndex="availability"
                                                        key="availability"
                                                        align="center"
                                                        render={(_, record) => record.availability ? record.availability : 'unpublished'}
                                                    />
                                                    <Column
                                                        title="Created at"
                                                        dataIndex={'createdAt'}
                                                        key='createdAt'
                                                        align='center'
                                                        render={(_, record) => record.createdAt ? record.createdAt : '-'}
                                                    />
                                                    <Column
                                                        title="Action"
                                                        align='center'
                                                        render={(_, record) => (
                                                            <Space align='center'>
                                                                <Tooltip title="Play">
                                                                    {/* <Button onClick={() => { playStandAloneContent(record) }} ><PlaySquareFilled /></Button> */}
                                                                </Tooltip>
                                                                <Tooltip title="Edit">
                                                                    <Button onClick={() => { handleFetchMovie(record); setMovieName(record.title) }}><EditFilled /></Button>
                                                                </Tooltip>
                                                                <Tooltip title={record.availability === "unpublished" ? "Publish" : "Unpublish"}>
                                                                    <Button onClick={() => { publishStandaloneContent(record) }}>
                                                                        {
                                                                            record.availability === "unpublished" ? <InteractionOutlined /> : <InteractionFilled />
                                                                        }
                                                                    </Button>
                                                                </Tooltip>
                                                                <Tooltip title="Delete">
                                                                    <Button onClick={() => { handleDeleteStandaloneContent(record); }}><DeleteFilled /></Button>
                                                                </Tooltip>
                                                            </Space>
                                                        )}
                                                    >
                                                    </Column>
                                                </Table>
                                            </>
                                        )}
                                    </TabPane>
                                    <TabPane
                                        tab={
                                            <>
                                                <div className="tabMainTitle">Episodic</div>
                                                <span className="tabSubTitle">
                                                    TV Shows, Web Series
                                                </span>
                                            </>
                                        }
                                        key={2}
                                    >
                                        {showTable && (
                                            <>
                                                <Row>
                                                    <Select
                                                        placeholder="Search Series"
                                                        showSearch
                                                        allowClear
                                                        onChange={(_, record) => {
                                                            sessionStorage.setItem('content_id', record.key);
                                                            handleFetchSeries(record);
                                                        }}
                                                        onClear={() => setFilter('all')}
                                                        style={{
                                                            width: '100%',
                                                            marginBottom: '15px',
                                                        }}
                                                        optionFilterProp="children"
                                                        filterOption={(input, option) =>
                                                            option.children
                                                                .toLowerCase()
                                                                .indexOf(input.toLowerCase()) >= 0
                                                        }
                                                        filterSort={(optionA, optionB) =>
                                                            optionA.children
                                                                .toLowerCase()
                                                                .localeCompare(optionB.children.toLowerCase())
                                                        }
                                                    >
                                                        {series.map((m) => (
                                                            <Option key={m.key} value={m.title}>
                                                                {m.title}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </Row>
                                                <Row
                                                    justify={'space-between'}
                                                    style={{ marginBottom: '25px' }}
                                                >
                                                    <Col>
                                                        {!showModal && (
                                                            <Button
                                                                className="title-btn"
                                                                type="primary"
                                                                onClick={() => {
                                                                    setSeriesTitleModal(true);
                                                                    console.log('series title modal is - ', seriesTitleModal)
                                                                }}
                                                            >
                                                                Add Title
                                                            </Button>
                                                        )}
                                                    </Col>
                                                    <Col>
                                                        <Select
                                                            defaultValue="all"
                                                            style={{ width: 120 }}
                                                            allowClear
                                                            onChange={(value) => setFilter(value)}
                                                            options={[
                                                                { value: 'all', label: 'View All' },
                                                                { value: 'draft', label: 'Draft' },
                                                                { value: 'published', label: 'Published' },
                                                            ]}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Table dataSource={series}>
                                                    <Column
                                                        title="Title"
                                                        dataIndex="title"
                                                        key="title"
                                                        align="left"
                                                        paddingLeft={'3%'}
                                                        width={'50%'}
                                                        render={(_, record) => record.title ? record.title : '-'}
                                                    />
                                                    <Column
                                                        title="Seasons"
                                                        align='center'
                                                        render={(_, record) => record.seasons ? `${record.seasons}` : '1'}
                                                    />
                                                    <Column
                                                        title="Episodes"
                                                        align='center'
                                                        render={(_, record) => record.episodes ? record.episodes.length : '0'}
                                                    />
                                                    <Column
                                                        title="Status"
                                                        dataIndex="availability"
                                                        key="availability"
                                                        align="center"
                                                        render={(_, record) => record.availability ? record.availability : 'unpublished'}
                                                    />
                                                    <Column
                                                        title="Created at"
                                                        dataIndex={'createdAt'}
                                                        key='createdAt'
                                                        align='center'
                                                        render={(_, record) => record.createdAt ? record.createdAt : '-'}
                                                    />
                                                    <Column
                                                        title="Action"
                                                        align='center'
                                                        render={(_, record) => (
                                                            <Space align='center'>
                                                                {/* <Button onClick={() => { playSeriesContent(record) }}><PlaySquareFilled /></Button> */}
                                                                <Button onClick={() => { sessionStorage.setItem('content_id', record.key); handleFetchSeries(record); }}><EditFilled /></Button>
                                                                <Tooltip title={record.availability === "unpublished" ? "Publish" : "Unpublish"}>
                                                                    <Button onClick={() => { publishEpisodicContent(record) }}>
                                                                        {
                                                                            record.availability === "unpublished" ? <InteractionOutlined /> : <InteractionFilled />
                                                                        }
                                                                    </Button>
                                                                </Tooltip>
                                                                <Button onClick={() => { handleDeleteSeriesContent(record) }}><DeleteFilled /></Button>
                                                            </Space>
                                                        )}
                                                    >
                                                    </Column>
                                                </Table>
                                            </>
                                        )}
                                    </TabPane>
                                </Tabs>
                            </Col>
                        </Row>
                    </>
                ) : (
                    ''
                )}
                {/* Adding detail content of Standalone */}

                {addStandaloneContent && (
                        <Row>
                            <Col span={24}>
                                <Row>
                                    <Col span={24} style={{ marginBottom: '20px' }}>
                                        <Breadcrumb
                                            items={[
                                                {
                                                    title: <a onClick={handleReset}> Table of Contents </a>
                                                },
                                                {
                                                    title: <a href="#">{movie.title}</a>,
                                                },
                                            ]}
                                        />
                                        <Title level={3} style={{ marginBottom: '10px' }}>
                                            {movie.title}
                                        </Title>
                                        <Text type="secondary">
                                            <>
                                                <Tag
                                                    color="blue"
                                                    style={{
                                                        borderRadius: '100px',
                                                        paddingLeft: '10px',
                                                        paddingRight: '10px',
                                                    }}
                                                >
                                                    English
                                                </Tag>
                                                {Telugu && (<Tag
                                                    color="blue"
                                                    style={{
                                                        borderRadius: '100px',
                                                        paddingLeft: '10px',
                                                        paddingRight: '10px',
                                                    }}
                                                >
                                                    Telugu
                                                </Tag>)}
                                                {Hindi && (<Tag
                                                    color="blue"
                                                    style={{
                                                        borderRadius: '100px',
                                                        paddingLeft: '10px',
                                                        paddingRight: '10px',
                                                    }}
                                                >
                                                    Hindi
                                                </Tag>)}
                                                {Tamil && (<Tag
                                                    color="blue"
                                                    style={{
                                                        borderRadius: '100px',
                                                        paddingLeft: '10px',
                                                        paddingRight: '10px',
                                                    }}
                                                >
                                                    Tamil
                                                </Tag>)}
                                            </>
                                            <Popover
                                                content={addLanguagePopover}
                                                trigger="click"
                                                placement="bottom"
                                                title="Add a Language"
                                            >
                                                <Button
                                                    size="small"
                                                    style={{ paddingLeft: '10px', paddingRight: '10px' }}
                                                >
                                                    Add
                                                </Button>
                                            </Popover>
                                        </Text>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24} style={{ marginTop: '15px' }}>
                                <Tabs
                                    activeKey={activeKey}
                                    className="add-content-tabs addContentTabs"
                                    onChange={setActiveKey}
                                >
                                    <TabPane
                                        tab={<label>Catalog Listing</label>}
                                        key="1"
                                    >
                                        <Form layout="vertical" form={contentInfoForm}>
                                            <Row gutter={30}>
                                                <Col span={12}>
                                                    <Form.Item
                                                        name={'title'}
                                                        label="Title"
                                                        rules={[{ required: true }]}
                                                        tooltip="Some information about this title displays here"
                                                        extra="English"
                                                    >
                                                        <Input
                                                            placeholder="Enter title here..."
                                                            value={movie.title}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item
                                                        name={'category'}
                                                        label="Category"
                                                        rules={[{ required: true }]}
                                                        tooltip="Some information about this title displays here"
                                                    >
                                                        <Select
                                                            defaultValue="movie"
                                                            onChange={setContentType}
                                                            placeholder="Select a category"
                                                            disabled={true}
                                                            value={movie.category}
                                                        >
                                                            <Option value="movie">Movie</Option>
                                                            <Option value="song">Song</Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            {Telugu && (<Row gutter={30}>
                                                <Col span={12}>
                                                    <Form.Item
                                                        name={'teluguTitle'}
                                                        label="Telugu Title"
                                                        rules={[{ required: true }]}
                                                        tooltip="Some information about this title displays here"
                                                        extra="Telugu"
                                                    >
                                                        <Input
                                                            placeholder="Enter title here..."
                                                            value={movie.TeluguTitle}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>)}
                                            {Hindi && (<Row gutter={30}>
                                                <Col span={12}>
                                                    <Form.Item
                                                        name={'hindiTitle'}
                                                        label="Hindi Title"
                                                        required
                                                        tooltip="Some information about this title displays here"
                                                        extra="Hindi"
                                                    >
                                                        <Input
                                                            placeholder="Enter title here..."
                                                            value={movie.HindiTitle}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>)}
                                            {Tamil && (<Row gutter={30}>
                                                <Col span={12}>
                                                    <Form.Item
                                                        name={'tamilTitle'}
                                                        label="Tamil Title"
                                                        rules={[{ required: true }]}
                                                        tooltip="Some information about this title displays here"
                                                        extra="Tamil"
                                                    >
                                                        <Input
                                                            placeholder="Enter title here..."
                                                            value={movie.TamilTitle}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>)}
                                            <Divider style={{ marginTop: 0 }} />
                                            <Row gutter={30}>
                                                <Col span={24}>
                                                    <Form.Item
                                                        name={'description'}
                                                        dataIndex={'description'}
                                                        label="Synopsis"
                                                        rules={[{ required: true }]}
                                                        tooltip="Some information about this title displays here"
                                                    >
                                                        <TextArea
                                                            rows={4}
                                                            placeholder="Enter short description of the movie"
                                                            showCount
                                                            maxLength={100}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            {Telugu && (<Row gutter={30}>
                                                <Col span={24}>
                                                    <Form.Item
                                                        name={'teluguDescription'}
                                                        dataIndex={'germanDescription'}
                                                        label="Synopsis (Telugu)"
                                                        rules={[{ required: true }]}
                                                        tooltip="Some information about this title displays here"
                                                    >
                                                        <TextArea
                                                            rows={4}
                                                            placeholder="Enter short description of the movie"
                                                            showCount
                                                            maxLength={100}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>)}
                                            {Hindi && (<Row gutter={30}>
                                                <Col span={24}>
                                                    <Form.Item
                                                        name={'hindiDescription'}
                                                        dataIndex={'HindiDescription'}
                                                        label="Synopsis (Hindi)"
                                                        rules={[{ required: true }]}
                                                        tooltip="Some information about this title displays here"
                                                    >
                                                        <TextArea
                                                            rows={4}
                                                            placeholder="Enter short description of the movie"
                                                            showCount
                                                            maxLength={100}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>)}
                                            {Tamil && (<Row gutter={30}>
                                                <Col span={24}>
                                                    <Form.Item
                                                        name={'tamilDescription'}
                                                        dataIndex={'TamilDescription'}
                                                        label="Synopsis (Tamil)"
                                                        rules={[{ required: true }]}
                                                        tooltip="Some information about this title displays here"
                                                    >
                                                        <TextArea
                                                            rows={4}
                                                            placeholder="Enter short description of the movie"
                                                            showCount
                                                            maxLength={100}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>)}
                                            <Row gutter={30}>
                                                <Col span={24}>
                                                    <Form.Item
                                                        name={'genre'}
                                                        dataIndex={'genre'}
                                                        label="Genre"
                                                        rules={[{ required: true }]}
                                                        tooltip="Some information about this title displays here"
                                                    >
                                                        <Select
                                                            mode="multiple"
                                                            placeholder="Select a genre"
                                                            showSearch
                                                        >
                                                            {genres && genres.map((genre) => (
                                                                <Option value={genre.name}>{genre.name}</Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={30}>
                                                <Col span={24}>
                                                    <Form.Item
                                                        name={'originCountry'}
                                                        dataIndex={'originCountry'}
                                                        label="Country/Region of origin"
                                                        rules={[{ required: true }]}
                                                        tooltip="Some information about this title displays here"
                                                        extra="The order of countries/regions is important, with the first entry corresponding to the production company with the greatest contribution to the title."
                                                    >
                                                        <Select
                                                            placeholder={"Select a country"}
                                                            showSearch
                                                        >
                                                            {Object.entries(countryCodes).map(([code, name]) => (
                                                                <Option key={code} value={code} >
                                                                    {name}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={30}>
                                                <Col span={12}>
                                                    <Form.Item
                                                        name={"language"}
                                                        label="Original language (Optional)"
                                                        tooltip="Some information about this title displays here"
                                                    >
                                                        <Select
                                                            placeholder="Select a language"
                                                            mode='multiple'
                                                            showSearch
                                                        >
                                                            {languages && languages.map((language) => (
                                                                <Option value={language.name}>{language.name}</Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item name="releaseData" label="Original release date">
                                                        <DatePicker style={{ width: '100%' }} />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Divider style={{ marginTop: 0 }} />
                                            <Row>
                                                <Col>
                                                    <Title level={5}>
                                                        Rating{' '}
                                                        <Tooltip title="Rating description text runs here like this">
                                                            <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                                                        </Tooltip>
                                                    </Title>
                                                </Col>
                                            </Row>
                                            <Divider style={{ margin: '10px 0' }} />
                                            <Row>
                                                <Col span={26}>
                                                    <Space
                                                        style={{
                                                            display: 'flex',
                                                            marginBottom: 8,
                                                        }}
                                                        align="baseline"
                                                    >
                                                        <Col span={18}>
                                                            <Form.Item
                                                                name={'ratingType'}
                                                                label="Rating System"
                                                                initialValue={ratingType}
                                                                rules={[{ required: true }]}
                                                            >
                                                                <Select style={{ width: '350px' }} onChange={setRatingType} defaultValue={'CBFC'}>
                                                                    {ratings.map((r) => (
                                                                        <Select.Option key={r.value}>{r.type}</Select.Option>
                                                                    ))}
                                                                </Select>
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={10}>
                                                            <Form.Item
                                                                name={'rating'}
                                                                label='Rating'
                                                                rules={[{ required: true }]}
                                                            >
                                                                <Select style={{ width: '100px' }}>
                                                                    {ratingType && ratingValues && ratingValues.map((v) => (
                                                                        <Select.Option key={v.key}>{v.value}</Select.Option>
                                                                    ))}
                                                                </Select>
                                                            </Form.Item>
                                                        </Col>
                                                    </Space>
                                                </Col>
                                            </Row>
                                            <Divider />
                                            <Row>
                                                <Col>
                                                    <Title level={5}>
                                                        Graphic assets{' '}
                                                        <Tooltip title="Rating description text runs here like this">
                                                            <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                                                        </Tooltip>
                                                    </Title>
                                                    <Text>
                                                        Key art (also known as cover or the title art)

                                                        represents your title on Prime Video.{' '}
                                                        <strong>
                                                            Please include legible titles on your key art.
                                                        </strong>{' '}
                                                        The optional background image adds visual interests
                                                        to video detail pages. For additional detail and
                                                        examples. See the{' '}
                                                        <Link href="#">Graphic Assets Guide.</Link>
                                                    </Text>
                                                </Col>
                                            </Row>

                                            <Row gutter={30} style={{ marginTop: '20px' }}>
                                                {/* 16:9 Image */}
                                                <Col span="8">
                                                    <Row>
                                                        <Col span={24}>
                                                            <Text>
                                                                <strong>Key art</strong> (16:9){' '}
                                                                <Tooltip title="Some description text runs here like this">
                                                                    <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                                                                </Tooltip>
                                                            </Text>
                                                        </Col>
                                                        <Col span={24} style={{ margin: '10px 0 5px 0' }}>
                                                            <Form.Item
                                                                name={'detailImage'}
                                                                rules={[{ required: true }]}
                                                            >
                                                                <Upload
                                                                    showUploadList={false}
                                                                    action={`${apiUrl}/uploads/fastpix-upload`}
                                                                    headers={{
                                                                        authorization: `Bearer ${token}`,
                                                                    }}
                                                                    beforeUpload={beforeImageUpload}
                                                                    onChange={handleDetailImageUploadStatusChange}
                                                                >
                                                                    <Button size="small">Browse...</Button>
                                                                </Upload>
                                                            </Form.Item>
                                                            {' '}
                                                            {/* <Button size="small">Google Drive</Button> */}
                                                        </Col>
                                                        <Col span={24}>
                                                            <Divider style={{ margin: '5px 0' }} />
                                                        </Col>
                                                        <Col span={24}>
                                                            {detailImageUrl ? (
                                                                <Image
                                                                    style={{
                                                                        aspectRatio: '16/9',
                                                                        objectFit: 'contain',
                                                                    }}
                                                                    src={detailImageUrl+ "/public"}
                                                                />
                                                            ) : (
                                                                <Text type="warning" style={{ marginRight: '10px' }}>
                                                                    <span>
                                                                        <WarningFilled />
                                                                    </span>{' '}
                                                                    Click to Upload Image
                                                                </Text>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </Col>

                                                {/* 3:4 Image */}
                                                <Col span="8">
                                                    <Row>
                                                        <Col span={24}>
                                                            <Text>
                                                                <strong>Key art</strong> (3:4){' '}
                                                                <Tooltip title="Some description text runs here like this">
                                                                    <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                                                                </Tooltip>
                                                            </Text>
                                                        </Col>
                                                        <Col span={24} style={{ margin: '10px 0 5px 0' }}>
                                                            <Form.Item
                                                                name={'cardImage'}
                                                                rules={[{ required: true }]}
                                                            >
                                                                <Upload
                                                                    showUploadList={false}
                                                                    action={`${apiUrl}/uploads/fastpix-upload`}
                                                                    headers={{
                                                                        authorization: `Bearer ${token}`,
                                                                    }}
                                                                    beforeUpload={beforeImageUpload}
                                                                    onChange={handleCardImageUploadStatusChange}
                                                                >
                                                                    <Button size="small">Browse...</Button>
                                                                </Upload>
                                                            </Form.Item>
                                                            {/* <Button size="small">Google Drive</Button> */}
                                                        </Col>
                                                        <Col span={24}>
                                                            <Divider style={{ margin: '5px 0' }} />
                                                        </Col>
                                                        <Col span={24}>
                                                            {cardImageUrl ? (
                                                                <Image
                                                                    style={{
                                                                        aspectRatio: '16/9',
                                                                        objectFit: 'contain',
                                                                    }}
                                                                    src={cardImageUrl + "/public"}
                                                                />
                                                            ) : (
                                                                <Text type="warning" style={{ marginRight: '10px' }}>
                                                                    <span>
                                                                        <WarningFilled />
                                                                    </span>{' '}
                                                                    Click to Upload Image
                                                                </Text>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </Col>

                                                {/* Background Image */}
                                                <Col span="8">
                                                    <Row>
                                                        <Col span={24}>
                                                            <Text>
                                                                Background Image (Optional){' '}
                                                                <Tooltip title="Some description text runs here like this">
                                                                    <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                                                                </Tooltip>
                                                            </Text>
                                                        </Col>
                                                        <Col span={24} style={{ margin: '10px 0 5px 0' }}>
                                                            <Form.Item
                                                                name={'trailerImage'}
                                                                rules={[{ required: true }]}
                                                            >
                                                                <Upload
                                                                    showUploadList={false}
                                                                    action={`${apiUrl}/uploads/fastpix-upload`}
                                                                    headers={{
                                                                        authorization: `Bearer ${token}`,
                                                                    }}
                                                                    beforeUpload={beforeImageUpload}
                                                                    onChange={handleTrailerImageUploadStatusChange}
                                                                >
                                                                    <Button size="small">Browse...</Button>
                                                                </Upload>
                                                            </Form.Item>
                                                            {/* <Button size="small">Google Drive</Button> */}
                                                        </Col>
                                                        <Col span={24}>
                                                            <Divider style={{ margin: '5px 0' }} />
                                                        </Col>
                                                        <Col span={24}>
                                                            {trailerImageUrl ? (
                                                                <Image
                                                                    style={{
                                                                        aspectRatio: '16/9',
                                                                        objectFit: 'contain',
                                                                    }}
                                                                    src={trailerImageUrl + "/public"}

                                                                />
                                                            ) : (
                                                                <Text type="warning" style={{ marginRight: '10px' }}>
                                                                    <span>
                                                                        <WarningFilled />
                                                                    </span>{' '}
                                                                    Click to Upload Image
                                                                </Text>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                            <Row justify="end" style={{ marginTop: '50px' }}>
                                                <Col span={24} style={{ textAlign: 'right' }}>
                                                    <Button type="primary" style={{ padding: '0 20px' }} onClick={handleContentInfoSubmit}>
                                                        Save
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </TabPane>
                                    <TabPane tab="Cast & Crew" key="2">
                                        <Form layout="vertical" form={castCrewAvailabilityForm}>
                                            <Row gutter={30}>
                                                <Col span={24}>
                                                    <Title level={4}>Studio/Creator</Title>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item name="studioName" label="Name" rules={[{ required: true }]}>
                                                        <Select
                                                            placeholder="Select studio Name here..."
                                                            showSearch mode="single" value={movie.studioName ? movie.studioName : null}
                                                            rules={[{ required: true }]}
                                                        >
                                                            {studios.map((studio) => (
                                                                <Option key={studio.name} value={studio.name}>
                                                                    {studio.name}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}></Col>
                                            </Row>
                                            <Divider style={{ marginTop: 0 }} />
                                            <Row>
                                                <Col span={24}>
                                                    <Title level={4} style={{ marginBottom: '0' }}>
                                                        Crew
                                                    </Title>
                                                    <Text type="secondary">
                                                        At least one crew member is required
                                                    </Text>
                                                </Col>
                                                <Col span={24} style={{ marginTop: '15px' }}>
                                                    <Row gutter={30} align="top">
                                                        <Col span={7}>
                                                            <Row>
                                                                <Col span={24}>
                                                                    <Form.Item name="directors" label="Directors" rules={[{ required: true }]} dataIndex={"directors"}>
                                                                        <Select placeholder="Select Directors here..."
                                                                            style={{ width: '360%' }}
                                                                            mode="multiple"
                                                                        >
                                                                            {directors && directors.map((director) => (
                                                                                <Option value={director.name}>
                                                                                    {director.name}
                                                                                </Option>))}
                                                                        </Select>
                                                                    </Form.Item>
                                                                    <Form.Item name={"writers"} label="Writers" rules={[{ required: true }]}>
                                                                        <Select placeholder="Select Writers here..."
                                                                            style={{ width: '360%' }}
                                                                            mode="multiple"
                                                                            value={movie.writers ? movie.writers : null}
                                                                        >
                                                                            {writers.map((writer) => (
                                                                                <Option key={writer.key} value={writer.name}>
                                                                                    {writer.name}
                                                                                </Option>
                                                                            ))}
                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col span={24}>
                                                            <Divider />
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col span={24}>
                                                            <Title level={4} style={{ marginBottom: '0' }}>
                                                                Cast
                                                            </Title>
                                                            <Text type="secondary">
                                                                The top two to four cast members provided below will
                                                                be indicated as Starring across Meander Video apps.
                                                            </Text>
                                                        </Col>
                                                        <Col span={24} style={{ marginTop: '15px' }}>
                                                            <Row gutter={30} align="middle">
                                                                <Col span={7}>
                                                                    <Row>
                                                                        <Col span={24}>Name</Col>
                                                                        <Col span={24}>
                                                                            <Form.Item name="actors" label="Actors" rules={[{ required: true }]}>
                                                                                <Select placeholder="Select Actors here..."
                                                                                    showSearch
                                                                                    mode="multiple"
                                                                                    // className="form-card-selector"
                                                                                    style={{ width: '360%' }}
                                                                                    value={movie.actors}
                                                                                    placement={'bottomLeft'}
                                                                                >
                                                                                    {actors.map((actor) => (
                                                                                        <Option key={actor.key} value={actor.name}>
                                                                                            {actor.name}
                                                                                        </Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={30}>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    <Divider />
                                                </Col>
                                            </Row>
                                            <Row justify="end">
                                                <Col span={24} style={{ textAlign: 'right' }}>
                                                    <Button type="primary" style={{ padding: '0 20px' }} onClick={handleCastCrewSubmit}>
                                                        Save
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </TabPane>
                                    <TabPane tab="Video assets" key="3">
                                        <Form layout="vertical" form={videoAssetsForm}>
                                            <Row gutter={30}>
                                                <Col span={24}>
                                                    <Title level={4}>
                                                        Video and Audio Files{' '}
                                                        <Tooltip title="Some description text runs here like this">
                                                            <span style={{ fontSize: '15px' }}>
                                                                <InfoCircleOutlined
                                                                    size="small"
                                                                    color="rgba(0, 0, 0, 0.45)"
                                                                />
                                                            </span>
                                                        </Tooltip>
                                                    </Title>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={24}>
                                                    <Row gutter={30}>
                                                        <Col span={6}>Mezzanine</Col>
                                                        <Col span={6}>
                                                            {"playbackUrl" in movie ? (
                                                                <Tag color="green" style={{ fontSize: 16 }}>
                                                                    Content Exists
                                                                </Tag>
                                                            ) : null}
                                                        </Col>
                                                        <Col span={6}>
                                                            <UploadVideo
                                                                id={
                                                                    activeObj && "_id" in activeObj
                                                                        ? activeObj._id
                                                                        : `contentupload-${contentType}`
                                                                }
                                                                upload={{ ...upload }}
                                                                activeObj={activeObj ? activeObj : {}}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={30} style={{ marginTop: '20px' }}>
                                                        <Col span={6}>Trailer (optional)</Col>
                                                        <Col span={6}>
                                                            {"trailer" in movie ? (
                                                                <Tag color="green" style={{ fontSize: 16 }}>
                                                                    Trailer Exists
                                                                </Tag>
                                                            ) : null}
                                                        </Col>
                                                        <Col span={6}>
                                                            <UploadTrailer
                                                                id={
                                                                    activeObj && "_id" in activeObj
                                                                        ? activeObj._id
                                                                        : `trailerupload-${contentType}`
                                                                }
                                                                upload={{
                                                                    ...upload,
                                                                    type:
                                                                        upload.type === "movies" ? "movie_trailer" : "series_trailer",
                                                                }}
                                                                activeObj={activeObj ? activeObj : {}}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={24}>
                                                    <Divider style={{ margin: '10px 0' }} />
                                                </Col>
                                                <Col span={24}>
                                                    <Form.List name="audio">
                                                        {(fields, { add, remove }) => (
                                                            <>
                                                                {fields.map(({ key, name, ...restField }) => (
                                                                    <Space
                                                                        key={key}
                                                                        style={{
                                                                            display: 'flex',
                                                                            marginBottom: 8,
                                                                        }}
                                                                        align="baseline"
                                                                    >
                                                                        <Form.Item
                                                                            {...restField}
                                                                            name={[name, 'l_audio']}
                                                                        >
                                                                            <UploadAudio
                                                                                id={
                                                                                    activeObj && "_id" in activeObj
                                                                                        ? activeObj._id
                                                                                        : `trailerupload-${contentType}`
                                                                                }
                                                                                upload={{
                                                                                    ...upload,
                                                                                    type:
                                                                                        upload.type === "movies" ? "movie_audio" : "episode_audio",
                                                                                }}
                                                                                activeObj={activeObj ? activeObj : {}}
                                                                            />
                                                                        </Form.Item>
                                                                        <CloseCircleFilled twoToneColor={'white'} onClick={() => remove(name)} />
                                                                    </Space>
                                                                ))}
                                                                <Form.Item>
                                                                    <Button onClick={() => add()}>
                                                                        Add Audio File
                                                                    </Button>
                                                                </Form.Item>
                                                            </>
                                                        )}
                                                    </Form.List>
                                                    {/* <Button>Add audio file</Button> */}
                                                </Col>
                                            </Row>

                                            <Row gutter={30} style={{ marginTop: '30px' }}>
                                                <Col span={24}>
                                                    <Title level={4}>
                                                        Timed Text{' '}
                                                        <Tooltip title="Some description text runs here like this">
                                                            <span style={{ fontSize: '15px' }}>
                                                                <InfoCircleOutlined
                                                                    size="small"
                                                                    color="rgba(0, 0, 0, 0.45)"
                                                                />
                                                            </span>
                                                        </Tooltip>
                                                    </Title>
                                                </Col>
                                                <Col span={24}>
                                                    <UploadSubtitles
                                                        style={{ marginTop: '10px' }}
                                                        id={`${movie}`}
                                                        upload={{
                                                            _id: sessionStorage.getItem('content_id'),
                                                            type: 'movie',
                                                        }}
                                                        subtitles={
                                                            movie && "subtitles" in movie ? movie.subtitles : {}
                                                        }
                                                    />
                                                    {movie.subtitles ? null : (
                                                        <Col span={10} style={{ marginTop: '10px' }}>
                                                            <Text type="warning">
                                                                <span>
                                                                    <WarningFilled />
                                                                </span> {" "}
                                                                No Timed text files have been added
                                                            </Text>
                                                        </Col>
                                                    )}
                                                </Col>
                                            </Row>
                                            <Divider />
                                            <Row gutter={30} style={{ marginTop: '30px' }}>
                                                <Col span={24}>
                                                    <Title level={4}>
                                                        Stream{' '}
                                                        <Tooltip title="Some description text runs here like this">
                                                            <span style={{ fontSize: '15px' }}>
                                                                <InfoCircleOutlined
                                                                    size="small"
                                                                    color="rgba(0, 0, 0, 0.45)"
                                                                />
                                                            </span>
                                                        </Tooltip>
                                                    </Title>
                                                </Col>
                                                <Col span={24}>
                                                    <Form.Item
                                                        name="skipIntroStart"
                                                        label="Skip Intro Start"
                                                    >
                                                        <InputNumber
                                                            placeholder="Enter start time in seconds"
                                                            disabled={contentType === "song"}
                                                            min={1}
                                                            max={18000}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item
                                                        name="skipIntroEnd"
                                                        label="Skip Intro End"
                                                    >
                                                        <InputNumber
                                                            placeholder="Enter end time in seconds"
                                                            disabled={contentType === "song"}
                                                            min={1}
                                                            max={18000}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Divider style={{ margin: '7px 0' }} />
                                                <Col span={24}>
                                                </Col>
                                            </Row>

                                            <Divider />


                                            <Row justify="end">
                                                <Col span={24} style={{ textAlign: 'right' }}>
                                                    <Button type="primary" style={{ padding: '0 20px' }} onClick={handleVideoAssestsSubmit}>
                                                        Save
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </TabPane>
                                    <TabPane tab="Availability" key="4">
                                        {/* Locations Table  */}
                                        <Row>
                                            <Col span={24}>
                                                <Form layout="vertical" form={geoAccessForm}>
                                                    <Form.Item name='listType' label={'Content access'} rules={[{ 'required': true }]} style={{ marginTop: '2%' }} noStyle initialValue={'allow_all'}>
                                                        <Radio.Group
                                                            value={listType}
                                                            onChange={(e) => setListType(e.target.value)}
                                                            defaultValue={'allow_all'}
                                                            style={{ marginTop: '1%' }}
                                                        >
                                                            <Radio value="allow_all">Allow Globally</Radio>
                                                            <Radio value="allow">Allow List</Radio>
                                                            <Radio value="disallow">Deny List</Radio>
                                                        </Radio.Group>
                                                    </Form.Item>

                                                    {['allow', 'disallow'].includes(listType) && (
                                                        <Form.Item
                                                            name={`countryMap`}
                                                            label={'Countries'}
                                                            rules={[{ required: true }]}
                                                            style={{ width: '100%', marginTop: '1%' }}
                                                        >
                                                            <Select
                                                                showSearch
                                                                mode="multiple"
                                                                placeholder={`Select countries to be ${listType}ed..`}
                                                                style={{ width: '100%' }}
                                                            >
                                                                {Object.entries(countryCodes).map(([code, name]) => (
                                                                    <Option key={code} value={code} >
                                                                        {name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>)}
                                                </Form>
                                            </Col>
                                        </Row>
                                        <Divider />
                                        {/* Pricing Model Block */}
                                        <Row>
                                            <Col span={24}>
                                                <Text>
                                                    <strong>
                                                        Which business model do you want to use?{' '}
                                                    </strong>
                                                    <Tooltip title="Some description text runs here like this">
                                                        <span style={{ fontSize: '15px' }}>
                                                            <InfoCircleOutlined
                                                                size="small"
                                                                color="rgba(0, 0, 0, 0.45)"
                                                            />
                                                        </span>
                                                    </Tooltip>
                                                </Text>
                                            </Col>
                                            <Form layout='vertical' form={monetizationStreamingForm}
                                            >
                                                <Row style={{ marginTop: '10px', marginBottom: '10px' }}>
                                                    <Radio.Group onChange={(e) => { setModelType(e.target.value); console.log(e.target.value) }} defaultValue='default'>
                                                        <Radio value={'subscription'}>Subscription</Radio>
                                                        <Radio value={'free'}>Free</Radio>
                                                        <Radio value={'rent'}>Buy & Rent</Radio>
                                                        {/* <Radio value={'3'}>Subsciption, Free & Rent</Radio> */}
                                                    </Radio.Group>
                                                </Row>
                                                {modelType === 'subscription' && (
                                                    <Row>
                                                    </Row>
                                                )}
                                                {modelType === 'free' && (
                                                    <Row>
                                                        {/* <Radio.Group onChange={(e) => setMonetizationModel(e.target.value)}>
                                                        <Radio value={'subscription'}>Subscription</Radio>
                                                        <Radio value={'free'}>Free</Radio>
                                                    </Radio.Group> */}
                                                    </Row>
                                                )}
                                                {modelType === 'rent' && (
                                                    <Row>
                                                        <Form.List name="currencyMap">
                                                            {(fields, { add, remove }) => (
                                                                <>
                                                                    <Space
                                                                        style={{
                                                                            display: 'flex',
                                                                            width: '100%'
                                                                        }}
                                                                        align="baseline"
                                                                    >
                                                                        <Form.Item
                                                                            name={'def_currency_1'}
                                                                            label="Currency"
                                                                            style={{ width: '100%' }}
                                                                            className="form-item-selector"
                                                                        >
                                                                            <Select style={{ width: '200px' }} defaultValue={'INR'}>
                                                                                {codes.map((cc) => (
                                                                                    <Select.Option key={cc} value={cc} placeholder={'Select a Currency'} >
                                                                                        {currencycodes[cc]}
                                                                                    </Select.Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Form.Item>
                                                                        <Form.Item
                                                                            name={'def_mrp_1'}
                                                                            label="MRP"
                                                                        >
                                                                            <InputNumber placeholder="Enter amount" />
                                                                        </Form.Item>
                                                                    </Space>
                                                                    <Space
                                                                        style={{
                                                                            display: 'flex',
                                                                            width: '100%',
                                                                            marginTop: -15,
                                                                        }}
                                                                        align="baseline"
                                                                    >
                                                                        <Form.Item
                                                                            name={'def_currency_2'}
                                                                            label="Currency"
                                                                            style={{ width: '100%' }}
                                                                            className="form-item-selector"
                                                                            noStyle
                                                                        >
                                                                            <Select style={{ width: '200px' }} defaultValue={'USD'}>
                                                                                {codes.map((cc) => (
                                                                                    <Select.Option key={cc} value={cc} placeholder={'Select a Currency'} >
                                                                                        {currencycodes[cc]}
                                                                                    </Select.Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Form.Item>
                                                                        <Form.Item
                                                                            name={'def_mrp_2'}
                                                                            label="MRP"
                                                                            noStyle
                                                                        >
                                                                            <InputNumber placeholder="Enter amount" />
                                                                        </Form.Item>
                                                                    </Space>
                                                                    {fields.map(({ key, name, ...restField }) => (
                                                                        <Space
                                                                            key={key}
                                                                            style={{
                                                                                display: 'flex',
                                                                                marginTop: 8,
                                                                                marginBottom: 8,
                                                                                width: '100%'
                                                                            }}
                                                                            align="baseline"
                                                                        >
                                                                            <Form.Item
                                                                                {...restField}
                                                                                name={[name, 'currency']}
                                                                                label="Currency"
                                                                                style={{ width: '100%', columnWidth: '40%' }}
                                                                                className="form-item-selector"
                                                                                noStyle
                                                                            >
                                                                                <Select style={{ width: '200px' }} placeholder={'Select a Currency'}>
                                                                                    {codes.map((cc) => (
                                                                                        <Select.Option key={cc} value={cc} placeholder={'Select a Currency'}>
                                                                                            {currencycodes[cc]}
                                                                                        </Select.Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </Form.Item>
                                                                            <Form.Item
                                                                                {...restField}
                                                                                name={[name, 'mrp']}
                                                                                label="MRP"
                                                                                noStyle
                                                                            >
                                                                                <InputNumber placeholder="Enter amount" />
                                                                            </Form.Item>
                                                                            {fields.length > 0 && key === (fields.length - 1) && fields.length <= 6 && (<>
                                                                                <PlusCircleOutlined onClick={() => add()} />
                                                                                <MinusCircleOutlined onClick={() => remove(name)} />
                                                                            </>)}
                                                                        </Space>
                                                                    ))}
                                                                    {fields.length === 0 && (<Form.Item style={{ marginTop: 8 }}>
                                                                        <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                                                            Add currency
                                                                        </Button>
                                                                    </Form.Item>)}
                                                                </>
                                                            )}
                                                        </Form.List>
                                                    </Row>
                                                )}
                                            </Form>
                                        </Row>
                                        <Divider />
                                        <Row justify="end">
                                            <Col span={24} style={{ textAlign: 'right' }}>
                                                <Button type="primary" style={{ padding: '0 20px' }} onClick={handleAvailabilitySubmit}>
                                                    Save
                                                </Button>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                </Tabs>
                            </Col>
                        </Row>
                )
                }
                {/* Adding details content for Episodes series */}
                {
                    addSeriesContent && (
                        <Row>
                            <Col span={24}>
                                <Row>
                                    <Col span={24}>
                                        <Row>
                                            <Breadcrumb
                                                items={[
                                                    {
                                                        title: <a onClick={handleReset}> Table of Contents </a>
                                                    },
                                                    {
                                                        title: <a href="#">{seriesId.title}</a>,
                                                    },
                                                ]}
                                            />
                                            <Col span={24}>
                                                <Title level={3} style={{ marginBottom: '10px' }}>
                                                    {seriesId.title}
                                                </Title>
                                                <Text type="secondary">:
                                                    <>
                                                        <Tag
                                                            color="blue"
                                                            style={{
                                                                borderRadius: '100px',
                                                                paddingLeft: '10px',
                                                                paddingRight: '10px',
                                                            }}
                                                        >
                                                            English
                                                        </Tag>
                                                        {Telugu && (<Tag
                                                            color="blue"
                                                            style={{
                                                                borderRadius: '100px',
                                                                paddingLeft: '10px',
                                                                paddingRight: '10px',
                                                            }}
                                                        >
                                                            Telugu
                                                        </Tag>)}
                                                        {Hindi && (<Tag
                                                            color="blue"
                                                            style={{
                                                                borderRadius: '100px',
                                                                paddingLeft: '10px',
                                                                paddingRight: '10px',
                                                            }}
                                                        >
                                                            Hindi
                                                        </Tag>)}
                                                    </>
                                                    <Popover
                                                        content={addLanguagePopover}
                                                        trigger="click"
                                                        placement="bottom"
                                                        title="Add a Language"
                                                    >
                                                        <Button
                                                            size="small"
                                                            style={{
                                                                paddingLeft: '10px',
                                                                paddingRight: '10px',
                                                            }}
                                                        >
                                                            Add
                                                        </Button>
                                                    </Popover>
                                                </Text>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24} style={{ marginTop: '15px' }}>
                                <Tabs
                                    //  activeKey="catalogListing"
                                    className="add-content-tabs addContentTabs"
                                >
                                    <TabPane
                                        tab={<label>Catalog Listing</label>}
                                        activeKey={activeKey}
                                        key="1"
                                    >
                                        <Form layout="vertical" form={seriesContentInfoForm}>
                                            <Row>
                                                <Col span={12}>
                                                    <Form.Item name={'season'} dataIndex='season' label="Season number" rules={[{ required: true }]}>
                                                        <Space>
                                                            <Button icon={<BackwardOutlined />} onClick={() => { seasonDown() }} disabled={season === 1} />
                                                            <InputNumber
                                                                // placeholder="Enter season number here..."
                                                                defaultValue={1}
                                                                onChange={(v) => setSeason(v)}
                                                                value={season}
                                                                controls={false}
                                                                style={{ width: '40px', }}
                                                            />
                                                            <Button icon={<ForwardOutlined />} onClick={() => seasonUp()} />
                                                        </Space>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={24}>
                                                    <Form.Item name="description" label="Synopsis" rules={[{ required: true }]} dataIndex={'description'}>
                                                        <TextArea
                                                            placeholder="Enter Synopsis here..."
                                                            tooltip="Some information about this title displays here"
                                                            extra="English"
                                                            showCount
                                                            maxLength={400}
                                                            rows="4"
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            {Telugu && (<Row gutter={30}>
                                                <Col span={24}>
                                                    <Form.Item
                                                        name={'teluguDescription'}
                                                        dataIndex={'teluguDescription'}
                                                        label="Synopsis (Telugu)"
                                                        rules={[{ required: true }]}
                                                        tooltip="Some information about this title displays here"
                                                    >
                                                        <TextArea
                                                            rows={4}
                                                            placeholder="Enter short description of the movie"
                                                            showCount
                                                            maxLength={100}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>)}
                                            {Hindi && (<Row gutter={30}>
                                                <Col span={24}>
                                                    <Form.Item
                                                        name={'hindiDescription'}
                                                        dataIndex={'hindiDescription'}
                                                        label="Synopsis (Hindi)"
                                                        rules={[{ required: true }]}
                                                        tooltip="Some information about this title displays here"
                                                    >
                                                        <TextArea
                                                            rows={4}
                                                            placeholder="Enter short description of the movie"
                                                            showCount
                                                            maxLength={100}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>)}
                                            {Tamil && (<Row gutter={30}>
                                                <Col span={24}>
                                                    <Form.Item
                                                        name={'tamilDescription'}
                                                        dataIndex={'tamilDescription'}
                                                        label="Synopsis (Tamil)"
                                                        rules={[{ required: true }]}
                                                        tooltip="Some information about this title displays here"
                                                    >
                                                        <TextArea
                                                            rows={4}
                                                            placeholder="Enter short description of the movie"
                                                            showCount
                                                            maxLength={100}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>)}
                                            <Row gutter={30}>
                                                <Col span={24}>
                                                    <Form.Item
                                                        name={'genre'}
                                                        label="Genre"
                                                        rules={[{ required: true }]}
                                                        tooltip="Some information about this title displays here"
                                                        dataIndex={'genre'}
                                                    >
                                                        <Select
                                                            mode="multiple"
                                                            showSearch
                                                        >
                                                            {genres && genres.map((genre) => (
                                                                <Option value={genre.name}>{genre.name}</Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={30}>
                                                <Col span={24}>
                                                    <Form.Item
                                                        name={'originCountry'}
                                                        dataIndex={'originCountry'}
                                                        label="Country/Region of origin"
                                                        rules={[{ required: true }]}
                                                        tooltip="Some information about this title displays here"
                                                        extra="The order of countries/regions is important, with the first entry corresponding to the production company with the greatest contribution to the title."
                                                    >
                                                        <Select
                                                            placeholder={"Select a country"}
                                                            showSearch
                                                        >
                                                            {Object.entries(countryCodes).map(([code, name]) => (
                                                                <Option key={code} value={code} >
                                                                    {name}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={30}>
                                                <Col span={12}>
                                                    <Form.Item
                                                        name={"language"}
                                                        label="Original language (Optional)"
                                                        tooltip="Some information about this title displays here"
                                                    >
                                                        <Select
                                                            placeholder="Select a language"
                                                            mode='multiple'
                                                            showSearch
                                                        >
                                                            {languages && languages.map((language) => (
                                                                <Option value={language.name}>{language.name}</Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item
                                                        // name="releaseDate"
                                                        label="Original release date"
                                                    // dataindex="releaseDate"
                                                    >
                                                        <DatePicker
                                                            format={"YYYY-MM-DD"}
                                                            // value={dateString}
                                                            style={{ width: '100%' }} />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Divider style={{ marginTop: 0 }} />
                                            <Row>
                                                <Col>
                                                    <Title level={5}>
                                                        Rating{' '}
                                                        <Tooltip title="Rating description text runs here like this">
                                                            <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                                                        </Tooltip>
                                                    </Title>
                                                </Col>
                                            </Row>
                                            <Divider style={{ margin: '10px 0' }} />
                                            <Row>
                                                <Col span={26}>
                                                    <Space
                                                        style={{
                                                            display: 'flex',
                                                            marginBottom: 8,
                                                        }}
                                                        align="baseline"
                                                    >
                                                        <Col span={18}>
                                                            <Form.Item
                                                                name={'ratingType'}
                                                                label="Rating System"
                                                                initialValue={ratingType}
                                                                rules={[{ required: true }]}
                                                            >
                                                                <Select style={{ width: '350px' }} onChange={setRatingType} defaultValue={'CBFC'}>
                                                                    {ratings.map((r) => (
                                                                        <Select.Option key={r.value}>{r.type}</Select.Option>
                                                                    ))}
                                                                </Select>
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={10}>
                                                            <Form.Item
                                                                name={'rating'}
                                                                label='Rating'
                                                                rules={[{ required: true }]}
                                                            >
                                                                <Select style={{ width: '100px' }}>
                                                                    {ratingType && ratingValues && ratingValues.map((v) => (
                                                                        <Select.Option key={v.key}>{v.value}</Select.Option>
                                                                    ))}
                                                                </Select>
                                                            </Form.Item>
                                                        </Col>
                                                    </Space>
                                                </Col>
                                            </Row>
                                            <Divider />
                                            <Row>
                                                <Col>
                                                    <Title level={5}>
                                                        Graphic assets{' '}
                                                        <Tooltip title="Rating description text runs here like this">
                                                            <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                                                        </Tooltip>
                                                    </Title>
                                                    <Text>
                                                        Key art (also known as cover or the title art)

                                                        represents your title on Prime Video.{' '}
                                                        <strong>
                                                            Please include legible titles on your key art.
                                                        </strong>{' '}
                                                        The optional background image adds visual interests
                                                        to video detail pages. For additional detail and
                                                        examples. See the{' '}
                                                        <Link href="#">Graphic Assets Guide.</Link>
                                                    </Text>
                                                </Col>
                                            </Row>
                                            <Row gutter={30} style={{ marginTop: '20px' }}>
                                                {/* 16:9 Image */}
                                                <Col span="8">
                                                    <Row>
                                                        <Col span={24}>
                                                            <Text>
                                                                <strong>Key art</strong> (16:9){' '}
                                                                <Tooltip title="Some description text runs here like this">
                                                                    <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                                                                </Tooltip>
                                                            </Text>
                                                        </Col>
                                                        <Col span={24} style={{ margin: '10px 0 5px 0' }}>
                                                            <Form.Item
                                                                name={'detailImage'}
                                                                rules={[{ required: true }]}
                                                            >
                                                                <Upload
                                                                    showUploadList={false}
                                                                    action={`${apiUrl}/uploads/fastpix-upload`}
                                                                    headers={{
                                                                        authorization: `Bearer ${token}`,
                                                                    }}
                                                                    beforeUpload={beforeImageUpload}
                                                                    onChange={handleDetailImageUploadStatusChange}
                                                                >
                                                                    <Button size="small">Browse...</Button>
                                                                </Upload>
                                                            </Form.Item>
                                                            {' '}
                                                            {/* <Button size="small">Google Drive</Button> */}
                                                        </Col>
                                                        <Col span={24}>
                                                            <Divider style={{ margin: '5px 0' }} />
                                                        </Col>
                                                        <Col span={24}>
                                                            {detailImageUrl ? (
                                                                <Image
                                                                    style={{
                                                                        aspectRatio: '16/9',
                                                                        objectFit: 'contain',
                                                                    }}
                                                                    src={detailImageUrl + "/public"}
                                                                />
                                                            ) : (
                                                                <Text type="warning" style={{ marginRight: '10px' }}>
                                                                    <span>
                                                                        <WarningFilled />
                                                                    </span>{' '}
                                                                    Click to Upload Image
                                                                </Text>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </Col>

                                                {/* 3:4 Image */}
                                                <Col span="8">
                                                    <Row>
                                                        <Col span={24}>
                                                            <Text>
                                                                <strong>Key art</strong> (3:4){' '}
                                                                <Tooltip title="Some description text runs here like this">
                                                                    <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                                                                </Tooltip>
                                                            </Text>
                                                        </Col>
                                                        <Col span={24} style={{ margin: '10px 0 5px 0' }}>
                                                            <Form.Item
                                                                name={'cardImage'}
                                                                rules={[{ required: true }]}
                                                            >
                                                                <Upload
                                                                    showUploadList={false}
                                                                    action={`${apiUrl}/uploads/fastpix-upload`}
                                                                    headers={{
                                                                        authorization: `Bearer ${token}`,
                                                                    }}
                                                                    beforeUpload={beforeImageUpload}
                                                                    onChange={handleCardImageUploadStatusChange}
                                                                >
                                                                    <Button size="small">Browse...</Button>
                                                                </Upload>
                                                            </Form.Item>
                                                            {/* <Button size="small">Google Drive</Button> */}
                                                        </Col>
                                                        <Col span={24}>
                                                            <Divider style={{ margin: '5px 0' }} />
                                                        </Col>
                                                        <Col span={24}>
                                                            {cardImageUrl ? (
                                                                <Image
                                                                    style={{
                                                                        aspectRatio: '16/9',
                                                                        objectFit: 'contain',
                                                                    }}
                                                                    src={cardImageUrl + "/public"}
                                                                />
                                                            ) : (
                                                                <Text type="warning" style={{ marginRight: '10px' }}>
                                                                    <span>
                                                                        <WarningFilled />
                                                                    </span>{' '}
                                                                    Click to Upload Image
                                                                </Text>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </Col>

                                                {/* Background Image */}
                                                <Col span="8">
                                                    <Row>
                                                        <Col span={24}>
                                                            <Text>
                                                                Background Image (Optional){' '}
                                                                <Tooltip title="Some description text runs here like this">
                                                                    <InfoCircleOutlined color="rgba(0, 0, 0, 0.45)" />
                                                                </Tooltip>
                                                            </Text>
                                                        </Col>
                                                        <Col span={24} style={{ margin: '10px 0 5px 0' }}>
                                                            <Form.Item
                                                                name={'trailerImage'}
                                                                rules={[{ required: true }]}
                                                            >
                                                                <Upload
                                                                    showUploadList={false}
                                                                    action={`${apiUrl}/uploads/fastpix-upload`}
                                                                    headers={{
                                                                        authorization: `Bearer ${token}`,
                                                                    }}
                                                                    beforeUpload={beforeImageUpload}
                                                                    onChange={handleTrailerImageUploadStatusChange}
                                                                >
                                                                    <Button size="small">Browse...</Button>
                                                                </Upload>
                                                            </Form.Item>
                                                            {/* <Button size="small">Google Drive</Button> */}
                                                        </Col>
                                                        <Col span={24}>
                                                            <Divider style={{ margin: '5px 0' }} />
                                                        </Col>
                                                        <Col span={24}>
                                                            {trailerImageUrl ? (
                                                                <Image
                                                                    style={{
                                                                        aspectRatio: '16/9',
                                                                        objectFit: 'contain',
                                                                    }}
                                                                    src={trailerImageUrl + "/public"}

                                                                />
                                                            ) : (
                                                                <Text type="warning" style={{ marginRight: '10px' }}>
                                                                    <span>
                                                                        <WarningFilled />
                                                                    </span>{' '}
                                                                    Click to Upload Image
                                                                </Text>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                            <Row gutter={30} style={{ marginTop: '20px' }}>

                                                {/* Background Image */}

                                            </Row>
                                            <Row justify="right" style={{ marginTop: '50px' }}>
                                                <Col span={24} style={{ textAlign: 'right' }}>
                                                    <Button type="primary" style={{ padding: '0 20px' }} onClick={handleSeriesContentInfoSubmit}>
                                                        Save
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </TabPane>
                                    <TabPane tab="Cast & Crew" key="2">
                                        <Form layout="vertical" form={seriesCastCrewAvailabilityForm}>
                                            <Row gutter={30}>
                                                <Col span={24}>
                                                    <Title level={4}>Studio/Creator</Title>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item name="studioName" label="Name" rules={[{ required: true }]}>
                                                        <Select
                                                            placeholder="Select studio Name here..."
                                                            showSearch mode="single" value={seriesId.studioName ? seriesId.studioName : null}>
                                                            {studios.map((studio) => (
                                                                <Option key={studio.name} value={studio.name}>
                                                                    {studio.name}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}></Col>
                                            </Row>
                                            <Divider style={{ marginTop: 0 }} />
                                            <Row>
                                                <Col span={24}>
                                                    <Title level={4} style={{ marginBottom: '0' }}>
                                                        Crew
                                                    </Title>
                                                    <Text type="secondary">
                                                        At least one crew member is required
                                                    </Text>
                                                </Col>
                                                <Col span={24} style={{ marginTop: '15px' }}>
                                                    <Row gutter={30} align="top">
                                                        <Col span={7}>
                                                            <Row>
                                                                <Col span={24}>
                                                                    <Form.Item name="directors" label="Directors" rules={[{ required: true }]} dataIndex={"directors"}>
                                                                        <Select placeholder="Select Directors here..."
                                                                            style={{ width: '360%' }}
                                                                            mode="multiple"
                                                                        >
                                                                            {directors && directors.map((director) => (
                                                                                <Option value={director.name}>
                                                                                    {director.name}
                                                                                </Option>))}
                                                                        </Select>
                                                                    </Form.Item>
                                                                    <Form.Item name={"writers"} label="Writers" rules={[{ required: true }]}>
                                                                        <Select placeholder="Select Writers here..."
                                                                            style={{ width: '360%' }}
                                                                            mode="multiple"
                                                                            value={seriesId.writers ? seriesId.writers : null}
                                                                        >
                                                                            {writers.map((writer) => (
                                                                                <Option key={writer.key} value={writer.name}>
                                                                                    {writer.name}
                                                                                </Option>
                                                                            ))}
                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col span={24}>
                                                            <Divider />
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col span={24}>
                                                            <Title level={4} style={{ marginBottom: '0' }}>
                                                                Cast
                                                            </Title>
                                                            <Text type="secondary">
                                                                The top two to four cast members provided below will
                                                                be indicated as Starring across Meander Video apps.
                                                            </Text>
                                                        </Col>
                                                        <Col span={24} style={{ marginTop: '15px' }}>
                                                            <Row gutter={30} align="middle">
                                                                <Col span={7}>
                                                                    <Row>
                                                                        <Col span={24}>Name</Col>
                                                                        <Col span={24}>
                                                                            <Form.Item name="actors" label="Actors" rules={[{ required: true }]}>
                                                                                <Select placeholder="Select Actors here..."
                                                                                    showSearch
                                                                                    mode="multiple"
                                                                                    // className="form-card-selector"
                                                                                    style={{ width: '360%' }}
                                                                                    value={seriesId.actors}
                                                                                    placement={'bottomLeft'}
                                                                                >
                                                                                    {actors.map((actor) => (
                                                                                        <Option key={actor.key} value={actor.name}>
                                                                                            {actor.name}
                                                                                        </Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={30}>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    <Divider />
                                                </Col>
                                            </Row>
                                            <Row justify="end">
                                                <Col span={24} style={{ textAlign: 'right' }}>
                                                    <Button type="primary" style={{ padding: '0 20px' }} onClick={handleSeriesCastCrewSubmit}>
                                                        Save
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </TabPane>
                                    <TabPane tab="Episodes" key="3">
                                        <Row>
                                            <Col span={24}>
                                                <Form layout="vertical" form={episodesForm}>
                                                    <Form.List name="episodes" dataIndex="episodes">
                                                        {(fields, { add, remove }) => (
                                                            <>
                                                                {fields.map(({ key, name, ...restField }) => (
                                                                    <>
                                                                        <Collapse>
                                                                            <Panel
                                                                                header={`Episode ${key + 1}`}
                                                                                key={key + 1}
                                                                                extra={episodesSortingButtons()}
                                                                            >
                                                                                <Row gutter={30}>
                                                                                    <Form.Item
                                                                                        {...restField}
                                                                                        name={[name, 'episode#']}
                                                                                        // initialValue={key + 1}
                                                                                        noStyle
                                                                                    />
                                                                                    <Col span={17}>
                                                                                        <Form.Item
                                                                                            {...restField}
                                                                                            name={[name, 'title']}
                                                                                            label="Title"
                                                                                            rules={[{ required: true }]}
                                                                                        >
                                                                                            <Input
                                                                                                placeholder="Enter title here..."
                                                                                                extra="English"
                                                                                            />
                                                                                        </Form.Item>
                                                                                    </Col>
                                                                                    <Col span={7}>
                                                                                        <Form.Item
                                                                                            {...restField}
                                                                                            name={[name, 'ep_release_date']}
                                                                                            label="Original release date"
                                                                                        >
                                                                                            <DatePicker style={{ width: '100%' }} />
                                                                                        </Form.Item>
                                                                                    </Col>
                                                                                    <Col span={17}>
                                                                                        {Telugu && (<Row gutter={30}>
                                                                                            <Col span={24}>
                                                                                                <Form.Item
                                                                                                    {...restField}
                                                                                                    name={[name, 'title_telugu']}
                                                                                                    label="Telugu Title"
                                                                                                    rules={[{ required: true }]}
                                                                                                >
                                                                                                    <Input
                                                                                                        placeholder="Enter title here..."
                                                                                                    // value={movie.TeluguTitle}
                                                                                                    />
                                                                                                </Form.Item>
                                                                                            </Col>
                                                                                        </Row>)}
                                                                                        {Hindi && (<Row gutter={30}>
                                                                                            <Col span={24}>
                                                                                                <Form.Item
                                                                                                    {...restField}
                                                                                                    name={[name, 'title_hindi']}
                                                                                                    label="Hindi Title"
                                                                                                    rules={[{ required: true }]}
                                                                                                >
                                                                                                    <Input
                                                                                                        placeholder="Enter title here..."
                                                                                                    // value={movie.HindiTitle}
                                                                                                    />
                                                                                                </Form.Item>
                                                                                            </Col>
                                                                                        </Row>)}
                                                                                        {Tamil && (<Row gutter={30}>
                                                                                            <Col span={24}>
                                                                                                <Form.Item
                                                                                                    {...restField}
                                                                                                    name={[name, 'title_tamil']}
                                                                                                    label="Tamil Title"
                                                                                                    rules={[{ required: true }]}
                                                                                                >
                                                                                                    <Input
                                                                                                        placeholder="Enter title here..."
                                                                                                    // value={movie.TamilTitle}
                                                                                                    />
                                                                                                </Form.Item>
                                                                                            </Col>
                                                                                        </Row>)}
                                                                                    </Col>
                                                                                    <Col span={7}>
                                                                                        <Row>
                                                                                            <Col span={24}>
                                                                                                Key art (4:3) (Optional){' '}
                                                                                                <Tooltip title="Some description text runs here like this">
                                                                                                    <span style={{ fontSize: '15px' }}>
                                                                                                        <InfoCircleOutlined
                                                                                                            size="small"
                                                                                                            color="rgba(0, 0, 0, 0.45)"
                                                                                                        />
                                                                                                    </span>
                                                                                                </Tooltip>
                                                                                            </Col>
                                                                                            <Col span={24}>
                                                                                                <Form.Item
                                                                                                    {...restField}
                                                                                                    name={[name, 'ep_cardImage']}
                                                                                                    rules={[{ required: true }]}
                                                                                                >
                                                                                                    <Upload
                                                                                                        showUploadList={true}
                                                                                                        progress={true}
                                                                                                        previewFile={true}
                                                                                                        accept={['image/png', 'image/jpeg', 'image/*']}
                                                                                                        action={`${apiUrl}/uploads/fastpix-upload`}
                                                                                                        maxCount={1}
                                                                                                        headers={{
                                                                                                            authorization: `Bearer ${token}`,
                                                                                                        }}
                                                                                                        beforeUpload={beforeImageUpload}
                                                                                                        onChange={handleCardImageUploadStatusChange}
                                                                                                        onPreview={handlePreview}
                                                                                                    >
                                                                                                        <Button size="small">Browse...</Button>
                                                                                                    </Upload>
                                                                                                </Form.Item>

                                                                                            </Col>
                                                                                            <Col>
                                                                                                {seriesId.episodes && key in seriesId.episodes && "ep_cardImage" in seriesId.episodes[key] && !cardImageLoading ? (
                                                                                                    <Image
                                                                                                        style={{
                                                                                                            aspectRatio: '16/9',
                                                                                                            objectFit: 'contain',
                                                                                                        }}
                                                                                                        src={!cardImageLoading ? (seriesId.episodes[key]).ep_cardImage : ""}
                                                                                                    />
                                                                                                ) : (
                                                                                                    <Text type="warning" style={{ marginRight: '10px' }}>
                                                                                                        <span>
                                                                                                            <WarningFilled />
                                                                                                        </span>{' '}
                                                                                                        Click to Upload Image
                                                                                                    </Text>
                                                                                                )}
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row>
                                                                                </Row>
                                                                                <Row>
                                                                                    <Col span={24}>
                                                                                        <Form.Item
                                                                                            {...restField}
                                                                                            name={[name, 'ep_description']}
                                                                                            label="Synopsis" rules={[{ required: true }]}>
                                                                                            <TextArea
                                                                                                placeholder="Enter description here..."
                                                                                                tooltip="Some information about this title displays here"
                                                                                                extra="English"
                                                                                                showCount
                                                                                                maxLength={400}
                                                                                                rows="4"
                                                                                            />
                                                                                        </Form.Item>
                                                                                    </Col>
                                                                                </Row>
                                                                                {Telugu && (<Row gutter={30}>
                                                                                    <Col span={24}>
                                                                                        <Form.Item
                                                                                            {...restField}
                                                                                            name={[name, 'ep_description_telugu']}
                                                                                            label="Synopsis (Telugu)" rules={[{ required: true }]}
                                                                                        >
                                                                                            <TextArea
                                                                                                rows={4}
                                                                                                placeholder="Enter short description of the movie"
                                                                                                showCount
                                                                                                maxLength={100}
                                                                                            />
                                                                                        </Form.Item>
                                                                                    </Col>
                                                                                </Row>)}
                                                                                {Hindi && (<Row gutter={30}>
                                                                                    <Col span={24}>
                                                                                        <Form.Item
                                                                                            {...restField}
                                                                                            name={[name, 'ep_description_hindi']}
                                                                                            label="Synopsis (Hindi)" rules={[{ required: true }]}
                                                                                        >
                                                                                            <TextArea
                                                                                                rows={4}
                                                                                                placeholder="Enter short description of the movie"
                                                                                                showCount
                                                                                                maxLength={100}
                                                                                            />
                                                                                        </Form.Item>
                                                                                    </Col>
                                                                                </Row>)}
                                                                                {Tamil && (<Row gutter={30}>
                                                                                    <Col span={24}>
                                                                                        <Form.Item
                                                                                            {...restField}
                                                                                            name={[name, 'ep_description_tamil']}
                                                                                            label="Synopsis (Tamil)" rules={[{ required: true }]}
                                                                                        >
                                                                                            <TextArea
                                                                                                rows={4}
                                                                                                placeholder="Enter short description of the movie"
                                                                                                showCount
                                                                                                maxLength={100}
                                                                                            />
                                                                                        </Form.Item>
                                                                                    </Col>
                                                                                </Row>)}
                                                                                <Row gutter={30}>
                                                                                    <Col span={24}>
                                                                                        <Title level={4}>
                                                                                            Video and Audio Files{' '}
                                                                                            <Tooltip title="Some description text runs here like this">
                                                                                                <span style={{ fontSize: '15px' }}>
                                                                                                    <InfoCircleOutlined
                                                                                                        size="small"
                                                                                                        color="rgba(0, 0, 0, 0.45)"
                                                                                                    />
                                                                                                </span>
                                                                                            </Tooltip>
                                                                                        </Title>
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row>
                                                                                    <Col span={24}>
                                                                                        <Row gutter={30}>
                                                                                            <Col span={6}>Mezzanine</Col>
                                                                                            {/* <Col span={6}>Raja_Rani_Movie.mp4</Col> */}
                                                                                            <Col span={6}>
                                                                                                {seriesId.episodes && key in seriesId.episodes && "playbackUrl" in seriesId.episodes[key] ? (
                                                                                                    <Tag color="green" style={{ fontSize: 16 }}>
                                                                                                        Content Exists
                                                                                                    </Tag>
                                                                                                ) : null}
                                                                                            </Col>
                                                                                            <Col span={6}>
                                                                                                <Form.Item
                                                                                                    {...restField}
                                                                                                    name={[name, 'ep_playbackUrl']}
                                                                                                >
                                                                                                    <UploadVideo
                                                                                                        id={
                                                                                                            activeObj && "_id" in activeObj
                                                                                                                ? activeObj._id
                                                                                                                : `contentupload-${contentType}`
                                                                                                        }
                                                                                                        upload={{ ...upload }}
                                                                                                        activeObj={activeObj ? activeObj : {}}
                                                                                                    />
                                                                                                </Form.Item>
                                                                                            </Col>
                                                                                        </Row>
                                                                                        <Row
                                                                                            gutter={30}
                                                                                            style={{ marginTop: '20px' }}
                                                                                        >
                                                                                            <Col span={6}>Trailer (optional)</Col>
                                                                                            <Col span={6}></Col>
                                                                                            <Col span={6}>
                                                                                                {seriesId.episodes && key in seriesId.episodes && "trailer" in seriesId.episodes[key] ? (
                                                                                                    <Tag color="green" style={{ fontSize: 16 }}>
                                                                                                        Trailer Exists
                                                                                                    </Tag>
                                                                                                ) : null}
                                                                                            </Col>
                                                                                            <Col span={6}>
                                                                                                <UploadTrailer
                                                                                                    id={
                                                                                                        activeObj && "_id" in activeObj
                                                                                                            ? activeObj._id
                                                                                                            : `trailerupload-${contentType}`
                                                                                                    }
                                                                                                    upload={{
                                                                                                        ...upload,
                                                                                                        type:
                                                                                                            upload.type === "movies" ? "movie_trailer" : "series_trailer",
                                                                                                    }}
                                                                                                    activeObj={activeObj ? activeObj : {}}
                                                                                                />
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row>
                                                                                    <Col span={24}>
                                                                                        <Divider style={{ margin: '10px 0' }} />
                                                                                    </Col>
                                                                                    <Col span={24}>
                                                                                        <Form.List name="audio">
                                                                                            {(fields, { add, remove }) => (
                                                                                                <>
                                                                                                    {fields.map(({ key, name, ...restField }) => (
                                                                                                        <Space
                                                                                                            key={key}
                                                                                                            style={{
                                                                                                                display: 'flex',
                                                                                                                marginBottom: 8,
                                                                                                            }}
                                                                                                            align="baseline"
                                                                                                        >
                                                                                                            <Form.Item
                                                                                                                {...restField}
                                                                                                                name={[name, 'l_audio']}
                                                                                                            >
                                                                                                                <UploadAudio
                                                                                                                    id={
                                                                                                                        activeObj && "_id" in activeObj
                                                                                                                            ? activeObj._id
                                                                                                                            : `trailerupload-${contentType}`
                                                                                                                    }
                                                                                                                    upload={{
                                                                                                                        ...upload,
                                                                                                                        type:
                                                                                                                            upload.type === "movies" ? "movie_audio" : "episode_audio",
                                                                                                                    }}
                                                                                                                    activeObj={activeObj ? activeObj : {}}
                                                                                                                />
                                                                                                            </Form.Item>
                                                                                                            <CloseCircleFilled twoToneColor={'white'} onClick={() => remove(name)} />
                                                                                                        </Space>
                                                                                                    ))}
                                                                                                    <Form.Item>
                                                                                                        <Button onClick={() => add()}>
                                                                                                            Add Audio File
                                                                                                        </Button>
                                                                                                    </Form.Item>
                                                                                                </>
                                                                                            )}
                                                                                        </Form.List>
                                                                                        {/* <Button>Add audio file</Button> */}
                                                                                    </Col>
                                                                                </Row>

                                                                                <Row gutter={30} style={{ marginTop: '30px' }}>
                                                                                    <Col span={24}>
                                                                                        <Title level={4}>
                                                                                            Timed Text{' '}
                                                                                            <Tooltip title="Some description text runs here like this">
                                                                                                <span style={{ fontSize: '15px' }}>
                                                                                                    <InfoCircleOutlined
                                                                                                        size="small"
                                                                                                        color="rgba(0, 0, 0, 0.45)"
                                                                                                    />
                                                                                                </span>
                                                                                            </Tooltip>
                                                                                        </Title>
                                                                                    </Col>
                                                                                    <Col span={24}>
                                                                                        <UploadSubtitles
                                                                                            style={{ marginTop: '10px' }}
                                                                                            id={`${movie}`}
                                                                                            upload={{
                                                                                                _id: sessionStorage.getItem('content_id'),
                                                                                                type: 'series',
                                                                                            }}
                                                                                            subtitles={
                                                                                                seriesId && seriesId.episodes && key in seriesId.episodes && "subtitles" in seriesId.episodes[key] ? seriesId.episodes[key].subtitles : {}
                                                                                            }
                                                                                        />
                                                                                        {seriesId.episodes && key in seriesId.episodes && seriesId.episodes[key].subtitles ? null : (
                                                                                            <Col span={10} style={{ marginTop: '10px' }}>
                                                                                                <Text type="warning">
                                                                                                    <span>
                                                                                                        <WarningFilled />
                                                                                                    </span> {" "}
                                                                                                    No Timed text files have been added
                                                                                                </Text>
                                                                                            </Col>
                                                                                        )}
                                                                                    </Col>
                                                                                </Row>
                                                                                <Divider style={{ marginTop: '3%' }} />
                                                                                <Row gutter={30} style={{ marginTop: '2%', marginBottom: '1%' }}>
                                                                                    <Col span={24}>
                                                                                        <Title level={4}>
                                                                                            Stream{' '}
                                                                                            <Tooltip title="Some description text runs here like this">
                                                                                                <span style={{ fontSize: '15px' }}>
                                                                                                    <InfoCircleOutlined
                                                                                                        size="small"
                                                                                                        color="rgba(0, 0, 0, 0.45)"
                                                                                                    />
                                                                                                </span>
                                                                                            </Tooltip>
                                                                                        </Title>
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row>
                                                                                    <Col>
                                                                                        <Form.Item
                                                                                            {...restField}
                                                                                            name={[name, 'ep_skipIntroStart']}
                                                                                            label="Skip Intro Start"
                                                                                        >
                                                                                            <InputNumber
                                                                                                placeholder="Enter start time in seconds"
                                                                                                min={1}
                                                                                                max={18000}
                                                                                            />
                                                                                        </Form.Item>
                                                                                    </Col>
                                                                                    <Col span={1}></Col>
                                                                                    <Col>
                                                                                        <Form.Item
                                                                                            {...restField}
                                                                                            name={[name, 'ep_skipIntroEnd']}
                                                                                            label="Skip Intro End"
                                                                                        >
                                                                                            <InputNumber
                                                                                                placeholder="Enter end time in seconds"
                                                                                                disabled={contentType === "song"}
                                                                                                min={1}
                                                                                                max={18000}
                                                                                            />
                                                                                        </Form.Item>
                                                                                    </Col>
                                                                                </Row>

                                                                                <Divider />

                                                                                <Row justify="end">
                                                                                    <Col span={24}>
                                                                                        <Form.Item
                                                                                            {...restField}
                                                                                            valuePropName="checked"
                                                                                            name={[name, 'del_box']}
                                                                                            initialValue={false}
                                                                                            noStyle>
                                                                                            <Checkbox
                                                                                                // onClick={(e) => { console.log('deleting ep - ', key + 1, e.target.checked); handleDeleteEpisode(key + 1, e.target.checked); }}
                                                                                                defaultValue={false}
                                                                                            >
                                                                                                Delete this episode
                                                                                            </Checkbox>
                                                                                        </Form.Item>

                                                                                    </Col>
                                                                                </Row>
                                                                            </Panel>
                                                                        </Collapse>
                                                                    </>
                                                                ))}
                                                                <Form.Item>
                                                                    <Row justify="end" style={{ marginTop: '15px' }}>
                                                                        <Col span={24}>
                                                                            <Button onClick={() => add()} type="primary" style={{ padding: '0 20px' }}>
                                                                                Add episode
                                                                            </Button>
                                                                        </Col>
                                                                    </Row>
                                                                </Form.Item>
                                                            </>
                                                        )}
                                                    </Form.List>
                                                </Form>
                                            </Col>
                                        </Row>
                                        <Divider />

                                        <Row justify="end">
                                            <Col span={24} style={{ textAlign: 'right' }}>
                                                <Button type="primary" style={{ padding: '0 20px' }} onClick={() => { handleEpisodeSubmit() }}>
                                                    Save
                                                </Button>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tab="Availability" key="4">
                                        {/* Locations Table  */}
                                        <Row>
                                            <Col span={24}>
                                                <Form layout="vertical" form={geoAccessForm}>
                                                    <Form.Item name='listType' label={'Content access'} rules={[{ 'required': true }]} style={{ marginTop: '2%' }} noStyle initialValue={'allow_all'}>
                                                        <Radio.Group
                                                            value={listType}
                                                            onChange={(e) => setListType(e.target.value)}
                                                            defaultValue={'allow_all'}
                                                            style={{ marginTop: '1%' }}
                                                        >
                                                            <Radio value="allow_all">Allow Globally</Radio>
                                                            <Radio value="allow">Allow List</Radio>
                                                            <Radio value="disallow">Deny List</Radio>
                                                        </Radio.Group>
                                                    </Form.Item>

                                                    {['allow', 'disallow'].includes(listType) && (
                                                        <Form.Item
                                                            name={`countryMap`}
                                                            label={'Countries'}
                                                            rules={[{ required: true }]}
                                                            style={{ width: '100%', marginTop: '1%' }}
                                                        >
                                                            <Select
                                                                showSearch
                                                                mode="multiple"
                                                                placeholder={`Select countries to be ${listType}ed..`}
                                                                style={{ width: '100%' }}
                                                            >
                                                                {Object.entries(countryCodes).map(([code, name]) => (
                                                                    <Option key={code} value={code} >
                                                                        {name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>)}
                                                </Form>
                                            </Col>
                                        </Row>
                                        <Divider />
                                        {/* Pricing Model Block */}
                                        <Row>
                                            <Col span={24}>
                                                <Text>
                                                    <strong>
                                                        Which pricing model do you want to use?{' '}
                                                    </strong>
                                                    <Tooltip title="Some description text runs here like this">
                                                        <span style={{ fontSize: '15px' }}>
                                                            <InfoCircleOutlined
                                                                size="small"
                                                                color="rgba(0, 0, 0, 0.45)"
                                                            />
                                                        </span>
                                                    </Tooltip>
                                                </Text>
                                            </Col>
                                            <Form layout='vertical' form={monetizationStreamingForm}>
                                                <Col span={24}>
                                                    <Form.Item name="model">
                                                        <Radio.Group
                                                            style={{ marginTop: '1%' }}
                                                            onChange={(e) => setMonetizationModel(e.target.value)}
                                                        >
                                                            <Radio value="rent">
                                                                Rent
                                                            </Radio>
                                                            <Radio value="subscription">Subscription</Radio>
                                                            <Radio value="free">Free</Radio>
                                                        </Radio.Group>
                                                    </Form.Item>
                                                    {monetizationModel === "rent" && (
                                                        <>
                                                            <Form.List name="currencyMap">

                                                                {(fields, { add, remove }) => (
                                                                    <>
                                                                        <Space
                                                                            style={{
                                                                                display: 'flex',
                                                                                width: '100%'
                                                                            }}
                                                                            align="baseline"
                                                                        >
                                                                            <Form.Item
                                                                                name={'def_currency_1'}
                                                                                label="Currency"
                                                                                style={{ width: '100%' }}
                                                                                className="form-item-selector"
                                                                            >
                                                                                <Select style={{ width: '200px' }} defaultValue={'INR'}>
                                                                                    {codes.map((cc) => (
                                                                                        <Select.Option key={cc} value={cc} placeholder={'Select a Currency'} >
                                                                                            {currencycodes[cc]}
                                                                                        </Select.Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </Form.Item>
                                                                            <Form.Item
                                                                                name={'def_mrp_1'}
                                                                                label="MRP"
                                                                            >
                                                                                <InputNumber placeholder="Enter amount" />
                                                                            </Form.Item>
                                                                        </Space>
                                                                        <Space
                                                                            style={{
                                                                                display: 'flex',
                                                                                width: '100%',
                                                                                marginTop: -15,
                                                                            }}
                                                                            align="baseline"
                                                                        >
                                                                            <Form.Item
                                                                                name={'def_currency_2'}
                                                                                label="Currency"
                                                                                style={{ width: '100%' }}
                                                                                className="form-item-selector"
                                                                                noStyle
                                                                            >
                                                                                <Select style={{ width: '200px' }} defaultValue={'USD'}>
                                                                                    {codes.map((cc) => (
                                                                                        <Select.Option key={cc} value={cc} placeholder={'Select a Currency'} >
                                                                                            {currencycodes[cc]}
                                                                                        </Select.Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </Form.Item>
                                                                            <Form.Item
                                                                                name={'def_mrp_2'}
                                                                                label="MRP"
                                                                                noStyle
                                                                            >
                                                                                <InputNumber placeholder="Enter amount" />
                                                                            </Form.Item>
                                                                        </Space>
                                                                        {fields.map(({ key, name, ...restField }) => (
                                                                            <Space
                                                                                key={key}
                                                                                style={{
                                                                                    display: 'flex',
                                                                                    marginTop: 8,
                                                                                    marginBottom: 8,
                                                                                    width: '100%'
                                                                                }}
                                                                                align="baseline"
                                                                            >
                                                                                <Form.Item
                                                                                    {...restField}
                                                                                    name={[name, 'currency']}
                                                                                    label="Currency"
                                                                                    style={{ width: '100%', columnWidth: '40%' }}
                                                                                    className="form-item-selector"
                                                                                    noStyle
                                                                                >
                                                                                    <Select style={{ width: '200px' }} placeholder={'Select a Currency'}>
                                                                                        {codes.map((cc) => (
                                                                                            <Select.Option key={cc} value={cc} placeholder={'Select a Currency'}>
                                                                                                {currencycodes[cc]}
                                                                                            </Select.Option>
                                                                                        ))}
                                                                                    </Select>
                                                                                </Form.Item>
                                                                                <Form.Item
                                                                                    {...restField}
                                                                                    name={[name, 'mrp']}
                                                                                    label="MRP"
                                                                                    noStyle
                                                                                >
                                                                                    <InputNumber placeholder="Enter amount" />
                                                                                </Form.Item>
                                                                                {fields.length > 0 && key === (fields.length - 1) && (<>
                                                                                    <PlusCircleOutlined onClick={() => add()} />
                                                                                    <MinusCircleOutlined onClick={() => remove(name)} />
                                                                                </>)}
                                                                            </Space>
                                                                        ))}
                                                                        {fields.length === 0 && (<Form.Item>
                                                                            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                                                                Add currency
                                                                            </Button>
                                                                        </Form.Item>)}
                                                                    </>
                                                                )}
                                                            </Form.List>
                                                        </>
                                                    )}
                                                </Col>
                                            </Form>
                                        </Row>
                                        <Divider />
                                        <Row justify="end">
                                            <Col span={24} style={{ textAlign: 'right' }}>
                                                <Button type="primary" style={{ padding: '0 20px' }} onClick={handleSeriesAvailabilitySubmit}>
                                                    Save
                                                </Button>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                </Tabs>
                            </Col>
                        </Row>
                    )
                }
            </div >

            {/* Standalone Modal */}
            < Modal
                title="Add Title"
                open={showModal}
                onCancel={() => setShowModal(false)}
                onOk={handleStandAloneTitleSubmit}
                okText={"Continue"}
            >
                <Form layout="vertical" form={addStandloneTitleForm}>
                    <Form.Item
                        label="Title"
                        rules={[{ required: true }]}
                        tooltip="Some information about this title displays here"
                        name={'title'}
                    >
                        <Input placeholder="Enter title here..." value="Raja Rani Movie" />
                    </Form.Item>

                    <Form.Item
                        label="Category"
                        rules={[{ required: true }]}
                        tooltip="Some information about this title displays here"
                        extra="Choose a title metadata language that matches the language of your mezzanine or captions."
                        name={'category'}
                        initialValue={'movie'}
                    >
                        <Select
                            defaultValue="movie"
                            placeholder="Select a Category"
                            // onChange={setContentType}
                            options={[
                                { value: 'movie', label: 'Movies' },
                                { value: 'shortfilms', label: 'Short Films' },
                                { value: 'clips', label: 'Clips' },
                                { value: 'concerts', label: 'Concerts and Performances' },
                                { value: 'educational', label: 'Educational' },
                                { value: 'interviews', label: 'Interviews' },
                                { value: 'musicvideos', label: 'Music Videos' },
                                { value: 'reporting', label: 'Reporting and Journalism' },
                                { value: 'sportingevents', label: 'Sporting Events' },
                            ]}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Title metadata language"
                        rules={[{ required: true }]}
                        tooltip="Some information about this title displays here"
                        name={'metaLanguage'}
                        initialValue={'english'}
                    >
                        <Select
                            defaultValue="english"
                            options={[
                                { value: 'english', label: 'English' },
                                { value: 'telugu', label: 'Telugu' },
                                { value: 'hindi', label: 'Hindi' },
                            ]}
                        />
                    </Form.Item>
                </Form>
            </Modal >

            {/* Episodes Modal */}
            < Modal
                title="Add Title"
                open={seriesTitleModal}
                onCancel={() => setSeriesTitleModal(false)}
                onOk={handleSeriesTitleSubmit}
                okText="Continue"
            >
                <Form layout="vertical" form={addSeriesTitleForm}>
                    <Form.Item
                        name={'title'}
                        label="Series title"
                        rules={[{ required: true }]}
                        tooltip="Some information about this title displays here"
                    >
                        <Input placeholder="Enter title here..." />
                    </Form.Item>
                    <Form.Item
                        label="Synopsis"
                        name="description"
                        rules={[{ required: true }]}
                        tooltip="Some information about this title displays here"
                    >
                        <TextArea rows={3} showCount maxLength={1000}></TextArea>
                    </Form.Item>

                    <Form.Item
                        label="Category"
                        name="category"
                        rules={[{ required: true }]}
                        tooltip="Some information about this title displays here"
                        extra="Choose a title metadata language that matches the language of your mezzanine or captions."
                        initialValue={'tvshows'}
                    >
                        <Select
                            defaultValue="tvshows"
                            options={[
                                { value: 'tvshows', label: 'TV Shows' },
                                { value: 'shortfilms', label: 'Short Films' },
                                { value: 'clips', label: 'Clips' },
                                { value: 'concerts', label: 'Concerts and Performances' },
                                { value: 'educational', label: 'Educational' },
                                { value: 'interviews', label: 'Interviews' },
                                { value: 'musicvideos', label: 'Music Videos' },
                                { value: 'reporting', label: 'Reporting and Journalism' },
                                { value: 'sportingevents', label: 'Sporting Events' },
                            ]}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Title metadata language"
                        rules={[{ required: true }]}
                        tooltip="Some information about this title displays here"
                        extra="Choose a title metadata language that matches the language of your mezzanine or captions. "
                        name="metaLanguage"
                        initialValue={'english'}
                    >
                        <Select
                            defaultValue="english"
                            options={[
                                { value: 'english', label: 'English' },
                                { value: 'telugu', label: 'Telugu' },
                                { value: 'hindi', label: 'Hindi' },
                            ]}
                        />
                    </Form.Item>
                </Form>
            </Modal >
        </>
    );
};

export default ManageContent;
